import React, { Fragment, useEffect, useState } from "react";
import {
    Container,
    DropdownMenu,
    DropdownToggle,
    Label,
    ModalBody,
    UncontrolledDropdown,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import InfoGif from "../../../assets/images/GIF/question-mark.gif";
import AccessDenied from "../../../assets/images/dribbble_1.gif";
import mauticImg from "../../../assets/images/Mautic_Logo_LB.png";
import meetIcon from "../../../assets/images/meeticon.png";
import usFlag from "../../../assets/images/flags/usa.png";
import ukFlag from "../../../assets/images/flags/uk.png";
import indiaFlag from "../../../assets/images/flags/india.png";
import canadaFlag from "../../../assets/images/flags/canadian_flag.jpg";
import "../../../assets/css/Sales/Lead.css";
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    Form,
    Badge,
    Modal,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import classnames from "classnames";
import Select from "react-select";
import sideImg from "../../../assets/images/profile-img.png";
// import ServerPagination from "components/Common/ServerPagination"

// assets
import "../../../assets/css/Sales/Sales.css";
import "../../../assets/css/Sales/Lead.css";

// common component
import Pagination from "components/Common/Pagination";
import ViewProfile from "./ViewLead/ViewProfile";
import ViewActivity from "./ViewLead/ViewActivity";
import ViewNotes from "./ViewLead/ViewNotes";
import Loader from "pages/Separate/Loader";
// Hover card
import axios from "axios";
import ViewFollowUp from "./ViewLead/ViewFollowUp";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Dropzone from "react-dropzone";
import swal from "sweetalert";
import moment from "moment";
import configure from "configure";
import Swal from "sweetalert2";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import AddMeeting from "./AddMeeting";
import AddTasks from "pages/Dashboard/GeneralTask/AddTasks";
import Draggable, { DraggableCore } from "react-draggable";
import { Resizable, ResizableBox } from "react-resizable";
import { fetchData, FetchNodePostData } from "utils/common-fetchData";
import { Tooltip } from "antd";
import {
    convertTimeZone,
    getInitials,
    getLeadStatus,
    transformGeneralData,
} from "utils/common-helpers";
import secureLocalStorage from "react-secure-storage";
import NewPagination from "components/Common/Newpagination";
import ServerPagination from "components/Common/serverPagination";
import { priorityOption } from "utils/common-options";
import { map } from "lodash";
// import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels"

const Lead = () => {
    const [modal_fullscreen, setmodal_fullscreen] = useState(false);
    const [viewId, setViewId] = useState("");
    const [verticalActiveTab, setverticalActiveTab] = useState("1");
    const [data, setDatas] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    // const [isLoading, setLoading] = useState(false)
    const [country, setCountry] = useState("");
    const [source, setSource] = useState(null);
    const [status, setStatus] = useState(null);
    const [assign, setAssign] = useState(null);
    const [description, setDescription] = useState("");
    const [type, setType] = useState([]);
    const [industry, setIndustry] = useState(null);
    const [location, setLocation] = useState([]);
    const [sourceIn_option, setInSource] = useState([]);
    const [sourceuk_option, setUkSource] = useState([]);
    const [userIn_option, setUserIn] = useState([]);
    const [useruk_option, setUserUk] = useState([]);
    const [alluser_option, setAllUsers] = useState([]);
    const [allsource_option, setAllSource] = useState([]);
    const [status_option, setStatusOption] = useState([]);
    const [industry_option, setIndustryOption] = useState([]);
    const [convertBtn, setConvertBtn] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(50);
    const [total, setTotal] = useState(0);
    const [hotCount, setHotCount] = useState(0);
    const [warmCount, setWarmCount] = useState(0);
    const [coldCount, setColdCount] = useState(0);
    const [normalCount, setNormalCount] = useState(0);
    const [fullLeadData, setFullLeadData] = useState([]); // stores ALL 60000+ leads
    const [fullLeadLoading, setFullLeadLoading] = useState(true);
    const [loadingCounter, setLoadingCounter] = useState(0);
    const [isNote, setIsNote] = useState(false);
    const [isFollowup, setIsFollowup] = useState(false);
    const [filterFollowDate, setFilterFollowDate] = useState("");
    // const [leadTypeModal, setLeadTypeModal] = useState(false)
    // const [selectedLead, setSelectedLead] = useState(null)
    // const [selectedLeadType, setSelectedLeadType] = useState(null)
    const [selectedLead, setSelectedLead] = useState(null);
    const [openLeadTypeDropdownId, setOpenLeadTypeDropdownId] = useState(null);
    const [openStatusDropdownId, setOpenStatusDropdownId] = useState(null);
    const [initialFetched, setInitialFetched] = useState(false);

    const isLoading = loadingCounter > 0;

    const startLoading = () => setLoadingCounter((prev) => prev + 1);
    const stopLoading = () => setLoadingCounter((prev) => Math.max(prev - 1, 0));

    const replyMessage = [{}, {}, {}, {}, {}, {}, {}];

    useEffect(() => {
        FilterData();
        fetchLongLeads();
        // fetch();
    }, []);

    useEffect(() => {
        if (initialFetched) onFilter();
    }, [initialFetched]);

    useEffect(() => {
        const handleOutsideClick = () => {
            setOpenLeadTypeDropdownId(null);
            setOpenStatusDropdownId(null);
        };

        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    useEffect(() => {
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("module_id", 17);

        axios({
            method: "post",
            url: `${configure.apiUrl}/earth_permission`,
            data: formData,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
            },
        })
            .then((res) => {
                if (res.data.data.india[1] == 1 && res.data.data.uk[1] == 1) {
                    setConvertBtn(true);
                } else {
                    setConvertBtn(false);
                }
            })
            .catch((err) => console.log(err));
    }, []);

    const type_option = [
        { label: "Hot", value: "1" },
        { label: "Cold", value: "2" },
        { label: "Warm", value: "3" },
        { label: "Normal", value: "4" },
        { label: "Extreme Hot", value: "5" },
    ];

    const leadTypeModalOptions = [
        { label: "Hot", value: "Hot" },
        { label: "Cold", value: "Cold" },
        { label: "Warm", value: "Warm" },
        { label: "Normal", value: "Normal" },
        { label: "Extreme Hot", value: "Extreme Hot" },
    ];

    const fetchLongLeads = async () => {
        try {
            const formData = new FormData();
            formData.append("user_id", localStorage.getItem("auth_id"));

            // do NOT startLoading()
            const res = await axios({
                method: "post",
                url: `${configure.nodeApi}/allLongLeads`,
                data: formData,
                headers: {
                    Accept: "application/json",
                },
            });

            setFullLeadData(res.data.data); // store all leads
            setFullLeadLoading(false); // enable search now
        } catch (error) {
            console.log("Background load failed:", error);
            setFullLeadLoading(false);
        }
    };

    // const fetch = async (page = 1, limit = 50, keyword = "", ) => {
    //   startLoading()
    //   const formData = new FormData()
    //   formData.append("user_id", localStorage.getItem("auth_id"))
    //   formData.append("location", "")
    //   formData.append("asigned", "")
    //   formData.append("status", "")
    //   formData.append("source", "")
    //   formData.append("page", page), formData.append("limit", limit)
    //   formData.append("keyword", keyword)
    //   try {
    //     const response = await axios({
    //       method: "post",
    //       url: `${configure.nodeApi}/all_lead`,
    //       data: formData,
    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "multipart/form-data",
    //       },
    //     })
    //     // const response = await FetchNodePostData(setLoading, "all_lead", secureLocalStorage.getItem("auth_token"),formData)

    //     setDisplayData(response.data.data)
    //     setDatas(response.data.data)
    //     setTotal(response.data.total)
    //     setHotCount(response.data.hotCount)
    //     setWarmCount(response.data.warmCount)
    //     setColdCount(response.data.coldCount)
    //     setNormalCount(response.data.normalCount)
    //     setCurrentPage(page)
    //     stopLoading()
    //   } catch (err) {
    //     console.log(err)
    //     stopLoading()
    //   }
    // }
    const [currentFilters, setCurrentFilters] = useState({
        location: "",
        asigned: "",
        status: "",
        source: "",
        lead_type: "",
        industry: "",
        keyword: "",
    });

    const [leadType, setLeadType] = useState("");

    const fetch = async (page = 1, limit = 50, keyword = "", filters = {}) => {
        startLoading();

        const {
            location = "",
            asigned = "",
            status = "",
            source = "",
            lead_type = "",
            industry = "",
        } = filters;

        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("location", location);
        formData.append("asigned", asigned);
        formData.append("status", status);
        formData.append("source", source);
        formData.append("lead_type", lead_type);
        formData.append("industry", industry);
        formData.append("page", page);
        formData.append("limit", limit);
        formData.append("keyword", keyword);

        try {
            const response = await axios({
                method: "post",
                url: `${configure.nodeApi}/all_lead`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            });

            setDisplayData(response.data.data);
            setDatas(response.data.data);
            setTotal(response.data.total);
            setHotCount(response.data.hotCount);
            setWarmCount(response.data.warmCount);
            setColdCount(response.data.coldCount);
            setNormalCount(response.data.normalCount);
            setCurrentPage(page);
            stopLoading();
        } catch (err) {
            console.log(err);
            stopLoading();
        }
    };

    // const toggleLeadTypeDropdown = lead => {
    //   setOpenLeadTypeDropdownId(prev => (prev === lead.id ? null : lead.id))
    // }

    // const toggleStatusDropdown = lead => {
    //   setOpenStatusDropdownId(prev => (prev === lead.id ? null : lead.id))
    // }

    const toggleLeadTypeDropdown = (lead) => {
        setOpenStatusDropdownId(null);
        setOpenLeadTypeDropdownId((prev) => (prev === lead.id ? null : lead.id));
    };

    const toggleStatusDropdown = (lead) => {
        setOpenLeadTypeDropdownId(null);
        setOpenStatusDropdownId((prev) => (prev === lead.id ? null : lead.id));
    };

    const handleLeadTypeChange = async (lead, nextLeadType) => {
        if (!lead || !nextLeadType) return;

        startLoading();

        try {
            const payload = {
                lead_id: lead.id,
                user_id: localStorage.getItem("auth_id"),
                lead_type: nextLeadType,
            };

            const response = await FetchNodePostData(
                null,
                "editLead/updateLeadType",
                localStorage.getItem("auth_token"),
                payload,
            );

            const patchLeadType = (item) =>
                item.id === lead.id
                    ? {
                        ...item,
                        lead_type: nextLeadType,
                    }
                    : item;

            setDatas((prev) => prev.map(patchLeadType));
            setDisplayData((prev) => prev.map(patchLeadType));
            setOpenLeadTypeDropdownId(null);

            Swal.fire({
                icon: "success",
                text: response?.data?.message || "Lead type updated successfully",
            });
        } catch (error) {
            console.log("Lead type update error:", error?.response?.data || error);

            Swal.fire({
                icon: "error",
                text: error?.response?.data?.message || "Failed to update lead type",
            });
        } finally {
            stopLoading();
        }
    };

    const handleStatusChange = async (leadId, nextStatus) => {
        if (!leadId || nextStatus === undefined || nextStatus === null) return;

        startLoading();

        const latestLead =
            data.find((item) => item.id === leadId) ||
            displayData.find((item) => item.id === leadId);

        if (!latestLead) {
            stopLoading();
            return;
        }

        const selectedStatusObj = status_option.find(
            (item) => String(item.value) === String(nextStatus),
        );

        try {
            const payload = {
                lead_id: latestLead.id,
                user_id: localStorage.getItem("auth_id"),
                status: nextStatus,
            };

            const response = await FetchNodePostData(
                null,
                "editLead/updateStatusType",
                localStorage.getItem("auth_token"),
                payload,
            );

            const patchRow = (item) =>
                item.id === leadId
                    ? {
                        ...item,
                        lead_status_id: nextStatus,
                        status: nextStatus,
                        sname: selectedStatusObj?.label || item.sname,
                    }
                    : item;

            setDatas((prev) => prev.map(patchRow));
            setDisplayData((prev) => prev.map(patchRow));

            setOpenStatusDropdownId(null);

            Swal.fire({
                icon: "success",
                text: response?.data?.message || "Status updated successfully",
            });
        } catch (error) {
            console.log("Status update error:", error?.response?.data || error);

            Swal.fire({
                icon: "error",
                text: error?.response?.data?.message || "Status update failed",
            });
        } finally {
            stopLoading();
        }
    };

    const [disable, setDiable] = useState(false);

    const FilterData = async () => {
        startLoading();
        try {
            const response = await axios({
                method: "get",
                url: `${configure.apiUrl}/filter_data`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then(async (response) => {
                setStatusOption(
                    getLeadStatus(
                        response.data.data.lead_status.map((obj) => ({
                            value: obj.id,
                            label: obj.name,
                        })),
                    ),
                );
                setInSource(
                    response.data.data.india_source.filter(item => item.location === 1)?.map((obj) => ({
                        value: obj.id,
                        label: obj.leadname,
                    })),
                );
                setUkSource(
                    response.data.data.india_source.filter(item => item.location === 2)?.map((obj) => ({
                        value: obj.id,
                        label: obj.leadname,
                    })),
                );
                setUserIn(
                    response.data.data.india_user.map((obj) => ({
                        value: obj.id,
                        label: obj.name,
                    })),
                );
                setUserUk(
                    response.data.data.uk_user.map((obj) => ({
                        value: obj.id,
                        label: obj.name,
                    })),
                );

                const users = [
                    ...response.data.data.uk_user,
                    ...response.data.data.india_user,
                ];
                const source = [
                    ...response.data.data.india_source,
                ];
                const jsonObject = users.map(JSON.stringify);
                const uniqueSet = new Set(jsonObject);
                const uniqueArray = Array.from(uniqueSet).map(JSON.parse);
                setAllUsers(
                    uniqueArray.map((obj) => ({
                        value: obj.id,
                        label: obj.name,
                    })),
                );

                const jsonObject1 = source.map(JSON.stringify);
                const uniqueSet1 = new Set(jsonObject1);
                const uniqueArray1 = Array.from(uniqueSet1).map(JSON.parse);
                setAllSource(
                    uniqueArray1.map((obj) => ({
                        value: obj.id,
                        label: obj.leadname,
                    })),
                );
                setIndustryOption(
                    response.data.data.industry?.map((obj) => ({
                        value: obj.id,
                        label: obj.name,
                    })),
                );

                const formData2 = new FormData();
                formData2.append("user_id", localStorage.getItem("auth_id"));
                const response2 = await axios({
                    method: "post",
                    url: `${configure.apiUrl}/show_lead_filter`,
                    data: formData2,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                }).then((res) => {
                    if (res.data.success == false) {
                        setDiable(true);
                    }
                    const datas = res.data.data[0];

                    if (datas.location == "1") {
                        setCountry({ label: "India", value: 1 });
                    } else if (datas.location == "2") {
                        setCountry({ label: "United Kingdom", value: 2 });
                    }
                    const sourceIds = datas?.source?.split(",").map(Number);
                    const statusIds = datas?.status?.split(",").map(Number);
                    const assignIds = datas?.assigned?.split(",").map(Number);
                    const typeIds = datas?.lead_type?.split(",");
                    const industryIds = datas?.industry?.split(",").map(Number);
                    setSource(
                        uniqueArray1
                            ?.filter((item) => sourceIds?.includes(item.id))
                            ?.map((obj) => ({
                                value: obj.id,
                                label: obj.leadname,
                            })),
                    );
                    setStatus(
                        getLeadStatus(
                            response.data.data?.lead_status
                                ?.filter((item) => statusIds?.includes(item.id))
                                ?.map((obj) => ({
                                    value: obj.id,
                                    label: obj.name,
                                })),
                        ),
                    );
                    setAssign(
                        uniqueArray
                            ?.filter((item) => assignIds?.includes(item.id))
                            ?.map((obj) => ({
                                value: obj.id,
                                label: obj.name,
                            })),
                    );
                    setType(type_option?.filter((item) => typeIds?.includes(item.value)));
                    setIndustry(
                        response.data.data?.industry
                            ?.filter((item) => industryIds?.includes(item.id))
                            ?.map((obj) => ({
                                value: obj.id,
                                label: obj.name,
                            })),
                    );
                });

                stopLoading();
            });
        } catch (err) {
            console.log(err);
            stopLoading();
        } finally {
            setInitialFetched(true);
        }
    };

    const toggleVertical = (tab) => {
        if (verticalActiveTab !== tab) {
            setverticalActiveTab(tab);
        }
    };

    const [lead_data, setLeadData] = useState([]);
    const [note_data, setNoteData] = useState([]);
    const [log_data, setLogData] = useState([]);
    const [follow_data, setFollowData] = useState([]);
    const [assigned_data, setAssignData] = useState([]);
    const [isFavorite, setIsFavorite] = useState(true);
    const [isFavoriteId, setIsFavoriteId] = useState(0);
    const [name_modal, setNameModal] = useState(false);
    //code for fetching lead data
    const followupdatacount = follow_data.length;
    const notesdatacount = note_data.length;
    // console.log("followupdatacount" ,followupdatacount)
    //  console.log("notesdatacount" ,notesdatacount)
    //meta title
    document.title = "Leads | Zithas Technologies";

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") setmodal_fullscreen(false);
    });

    const [view_assign, setViewAssign] = useState([]);
    const [created_at, setCreatedAt] = useState("");
    const [copiedId, setCopiedId] = useState(null);
    const toggleFavorite = async ({ leadId, fav }) => {
        swal({
            text: `${fav == 0
                ? "Are you sure you want to favorite this lead?"
                : "Are you sure you want to unfavorite this lead?"
                }`,
            icon: "warning",
            buttons: true,
        }).then(async (willOkay) => {
            if (willOkay) {
                setIsFavorite(!isFavorite); // Toggle favorite status
                const favValue = fav ? 0 : 1 || fav ? 1 : 0;
                setIsFavoriteId(fav);
                const formData = new FormData();
                formData.append("lead_id", leadId);
                formData.append("fav", favValue);
                formData.append("user_id", localStorage.getItem("auth_id"));
                formData.append("location", "");
                formData.append("asigned", "");
                formData.append("status", "");
                formData.append("source", "");
                startLoading();
                try {
                    const response = await axios({
                        method: "post",
                        data: formData,
                        url: `${configure.apiUrl}/isFavourite`,
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "multipart/form-data",
                        },
                    });
                    if (response) {
                        // console.log("isFavourite", response)
                        setDatas(response?.data?.data);
                        stopLoading();
                        // swal({
                        //   text: "FollowUp is completed",
                        //   icon: "success",
                        // }).then(() => {
                        //   setFollowUp(response.data.data)
                        // })
                    }
                    stopLoading();
                } catch (error) {
                    stopLoading();
                    console.log(error);
                }
            }
        });
    };

    const [copy, setCopy] = useState(null);

    const copyToClipBoard = async ({ text, id }) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopy(id);
            setTimeout(() => setCopy(null), 2000); // Reset after 2 secondsnull
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    // table columns
    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                isInfoIcon: false,
                className: "text-center",
                Cell: (cellProps) => {
                    // console.log("row Datas",cellProps.row.original)
                    return (
                        <div className="d-flex align-items-center gap-2">
                            {/* <i className="bi bi-star-fill text-purple"></i> */}
                            <button
                                className="btn border-0 p-0"
                                onClick={() =>
                                    toggleFavorite({
                                        leadId: cellProps.row.original.id,
                                        fav: cellProps.row.original.is_favourite,
                                    })
                                }
                            >
                                <i
                                    className={`bi fav-btn ${cellProps.row.original.is_favourite == 1
                                        ? "bi-star-fill text-star"
                                        : "bi-star"
                                        }`}
                                // onClick={() => addToFavorite(cellProps.row.original.id)}
                                ></i>
                            </button>
                            <span>{cellProps.row.original.id}</span>
                        </div>
                    );
                },
            },
            {
                Header: "",
                accessor: "assigned",
                Cell: (cellProps) => {
                    return (
                        <div className="text-center d-flex align-items-center">
                            <div className="profileImg-box">
                                {cellProps.row.original.asigned_avatar ? (
                                    <img
                                        src={`${configure.imgUrl}${cellProps.row.original.asigned_avatar}`}
                                        alt=""
                                        className="assigned-img mx-1"
                                        height="20"
                                        width="20"
                                    />
                                ) : (
                                    <div
                                        className="defualt-img"
                                        title={cellProps.row.original.asigned || "Z"}
                                    >
                                        {getInitials(cellProps.row.original.asigned || "Z")}
                                    </div>
                                )}
                                <div className="profileImg-detail">
                                    <div className="overflow-hidden mb-0 card">
                                        <div className="bg-primary bg-soft">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="text-primary text-start p-3">
                                                        <h5 className="text-primary ">
                                                            {cellProps.row.original.asigned}
                                                        </h5>
                                                        <p style={{ width: "200px" }}>
                                                            {cellProps.row.original.assign_designation}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="align-self-end col-4">
                                                    <img src={sideImg} alt="" className="img-fluid" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pt-0 mb-0 card-body">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="avatar-md profile-user-wid mb-2">
                                                        {cellProps.row.original.asigned_avatar ? (
                                                            <img
                                                                src={`${configure.imgUrl}${cellProps.row.original.asigned_avatar}`}
                                                                alt=""
                                                                style={{ width: "100%", height: "100%" }}
                                                                className="img-thumbnail rounded-circle"
                                                            />
                                                        ) : (
                                                            <div
                                                                className="defualt-img"
                                                                style={{ height: 60, width: 60, fontSize: 24 }}
                                                                title={cellProps.row.original.asigned || "Z"}
                                                            >
                                                                {getInitials(
                                                                    cellProps.row.original.asigned || "Z",
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <div className=" text-start">
                                                        <div className="row">
                                                            <div className="pe-1 col-5">
                                                                <h5 className="font-size-12 mb-1">Join Date</h5>
                                                                <p className=" font-size-12 text-muted mb-0">
                                                                    {cellProps.row.original.join_date}
                                                                </p>
                                                            </div>
                                                            <div className="ps-0 col-7">
                                                                <h5 className="font-size-12 mb-1">Email</h5>
                                                                <p className=" font-size-12 text-muted mb-0">
                                                                    {cellProps.row.original.assign_email}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {cellProps.row.original.lead_belongs_to == 1 ? (
                                <img
                                    src={indiaFlag}
                                    className=" mx-1 location-img"
                                    alt="flag"
                                    height="15"
                                    width="20"
                                />
                            ) : cellProps.row.original.lead_belongs_to == 2 ? (
                                <img
                                    src={ukFlag}
                                    className=" mx-1 location-img"
                                    alt="flag"
                                    height="15"
                                    width="20"
                                />
                            ) : cellProps.row.original.lead_belongs_to == 3 ? (
                                <img
                                    src={usFlag}
                                    className=" mx-1 location-img"
                                    alt="flag"
                                    height="15"
                                    width="20"
                                />
                            ) : cellProps.row.original.lead_belongs_to == 4 ? (
                                <img
                                    src={canadaFlag}
                                    className=" mx-1 location-img"
                                    alt="flag"
                                    height="15"
                                    width="20"
                                />) : null}
                        </div>
                    );
                },
                isInfoIcon: true,
            },
            {
                Header: "Company",
                accessor: "company",
                isInfoIcon: true,
                className: "cursor-pointer",
                Cell: (cellProps) => {
                    // const tooltipContent = (
                    //   <>
                    //     <p className="fs-6 body-font mb-0 text-purple fw-bold">
                    //       Notes : {cellProps.row.original?.leadsNotesdataCount}
                    //     </p>
                    //     <p className="fs-6 body-font mb-0 text-purple fw-bold">
                    //       Follow Ups : {cellProps.row.original?.leadsFollowupDataCount}
                    //     </p>
                    //   </>
                    // )
                    const currentLeadType = cellProps.row.original?.lead_type || "Lead";
                    const tooltipContent = (
                        <>
                            <p style={{ color: "purple", marginBottom: 0 }}>
                                {currentLeadType} - Note:{" "}
                                {cellProps.row.original?.currentNotesCount ?? 0}
                            </p>
                            <p style={{ color: "purple", marginBottom: 0 }}>
                                {currentLeadType} - follow up:{" "}
                                {cellProps.row.original?.currentFollowupCount ?? 0}
                            </p>
                            <p style={{ color: "blue", marginBottom: 0 }}>
                                Total notes: {cellProps.row.original?.totalNotesCount ?? 0}
                            </p>
                            <p style={{ color: "blue", marginBottom: 0 }}>
                                Total follow up:{" "}
                                {cellProps.row.original?.totalFollowupCount ?? 0}
                            </p>
                        </>
                    );
                    return (
                        <div className="d-flex justify-space-between align-items-center">
                            <Tooltip
                                color={"#752b97"}
                                title={`Service : ${cellProps.row.original?.service != null
                                    ? cellProps.row.original?.service
                                    : "Not Defined"
                                    }`}
                            >
                                <div>
                                    {cellProps.row.original.company !== null
                                        ? cellProps.row.original.company
                                        : "-"}
                                </div>
                            </Tooltip>
                            <div className="lead-type-popover-wrap">
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleLeadTypeDropdown(cellProps.row.original);
                                    }}
                                    style={{
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "start",
                                    }}
                                >
                                    <Tooltip
                                        color={"#f0e8f4"}
                                        title={
                                            openLeadTypeDropdownId === cellProps.row.original.id
                                                ? null
                                                : tooltipContent
                                        }
                                    >
                                        <span>
                                            {cellProps.row.original.lead_type == "Hot" ? (
                                                <i
                                                    className="bx bxs-hot"
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "0",
                                                        color: "#FF5733",
                                                    }}
                                                ></i>
                                            ) : cellProps.row.original.lead_type == "Warm" ? (
                                                <i
                                                    className="bx bxs-flame"
                                                    style={{
                                                        fontSize: "20px",
                                                        lineHeight: "0",
                                                        color: "#fdab99",
                                                    }}
                                                ></i>
                                            ) : cellProps.row.original.lead_type == "Cold" ? (
                                                <i
                                                    className="bx bxs-sun"
                                                    style={{
                                                        fontSize: "20px",
                                                        lineHeight: "0",
                                                        color: "#4ab3ff",
                                                    }}
                                                ></i>
                                            ) : cellProps.row.original.lead_type == "Extreme Hot" ? (
                                                <i
                                                    className="mdi mdi-fire-alert"
                                                    style={{
                                                        fontSize: "20px",
                                                        lineHeight: "0",
                                                        color: "#ff0000ff",
                                                    }}
                                                ></i>
                                            ) : null}
                                        </span>
                                    </Tooltip>
                                    <span
                                        title="current status notes count"
                                        className="badge bg-success ms-1 rounded-circle  fw-bold"
                                    >
                                        {cellProps.row.original?.currentNotesCount ?? 0}
                                    </span>
                                </div>

                                {openLeadTypeDropdownId === cellProps.row.original.id && (
                                    <div
                                        className="lead-type-popover-box"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {leadTypeModalOptions.map((item) => {
                                            const isActive =
                                                cellProps.row.original.lead_type === item.value;

                                            return (
                                                <div
                                                    key={item.value}
                                                    onClick={() =>
                                                        handleLeadTypeChange(
                                                            cellProps.row.original,
                                                            item.value,
                                                        )
                                                    }
                                                    className={`lead-type-option ${isActive ? "active" : ""
                                                        }`}
                                                >
                                                    {item.label}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                },
            },
            {
                Header: "Name",
                accessor: "person_details",
                isInfoIcon: true,
                // Cell: cellProps => {
                //   const personal = JSON.parse(cellProps?.row?.original?.person_details)
                //   let PersonName
                //   if (personal != null && personal?.length == 0) {
                //     PersonName = "-"
                //   } else if (personal != null) {
                //     PersonName = personal[0]?.person_name
                //   }
                //   return <div>{PersonName ? PersonName : "-"}</div>
                // },
                Cell: (cellProps) => {
                    const raw = cellProps?.row?.original?.person_details;

                    let personal = [];

                    try {
                        if (typeof raw === "string" && raw.trim() !== "") {
                            personal = JSON.parse(raw);
                        } else if (Array.isArray(raw)) {
                            personal = raw;
                        }
                    } catch (error) {
                        console.warn("Invalid JSON:", raw);
                        personal = [];
                    }

                    let PersonName = "-";

                    if (Array.isArray(personal) && personal.length > 0) {
                        PersonName = personal[0]?.person_name || "-";
                    }

                    return <div>{PersonName}</div>;
                },
            },
            {
                Header: "Email ID",
                accessor: "email",
                isInfoIcon: true,
                Cell: (cellProps) => {
                    const alldata = cellProps?.row?.original;

                    const email = alldata?.person_details
                        ? JSON.parse(alldata.person_details)[0]?.person_email
                            ? JSON.parse(alldata.person_details)[0].person_email
                            : alldata?.email != null
                                ? alldata?.email
                                : "-"
                        : alldata?.email != null
                            ? alldata?.email
                            : "-";

                    return (
                        <div className="d-flex justify-content-between">
                            {email}

                            {email && email != "-" && (
                                <span>
                                    <i
                                        className={`ps-3 bi ${`1-${alldata.id}` == copy
                                            ? "bi-check"
                                            : "bi-clipboard label-icon"
                                            } label-icon fa-lg`}
                                        style={{
                                            cursor: "pointer",
                                            color: "#a8a6a6",
                                        }}
                                        onClick={(e) =>
                                            copyToClipBoard({
                                                text: email,
                                                id: `1-${alldata.id}`,
                                            })
                                        }
                                        title="Click to Copy"
                                    ></i>
                                </span>
                            )}
                        </div>
                    );
                    // const personal = JSON.parse(cellProps.row.original.person_details)
                    // let PersonEmail
                    // if (personal != null && personal?.length == 0) {
                    //   PersonEmail = cellProps.row.original.email
                    // } else if (personal != null) {
                    //   PersonEmail = personal[0]?.person_email
                    // }
                    // return <div>{PersonEmail ? PersonEmail : "-"}</div>
                },
            },
            {
                Header: "Phone",
                accessor: "phone",
                isInfoIcon: true,
                Cell: (cellProps) => {
                    const alldata = cellProps.row.original;

                    const phone = alldata?.person_details
                        ? JSON.parse(alldata.person_details)[0]?.person_phone
                            ? JSON.parse(alldata.person_details)[0].person_phone
                            : alldata?.phonenumber != null
                                ? alldata?.phonenumber
                                : "-"
                        : alldata?.phonenumber != null
                            ? alldata?.phonenumber
                            : "-";

                    return (
                        <div className="d-flex justify-content-between">
                            {phone}
                            {phone && phone != "-" && (
                                <span>
                                    <i
                                        className={`ps-3 bi ${`2-${alldata.id}` == copy
                                            ? "bi-check"
                                            : "bi-clipboard label-icon"
                                            } label-icon fa-lg`}
                                        style={{
                                            cursor: "pointer",
                                            color: "#a8a6a6",
                                        }}
                                        onClick={(e) =>
                                            copyToClipBoard({
                                                text: phone,
                                                id: `2-${alldata.id}`,
                                            })
                                        }
                                        title="Click to Copy"
                                    ></i>
                                </span>
                            )}
                        </div>
                    );

                    // const personal = JSON.parse(cellProps.row.original.person_details)
                    // let PersonPhone
                    // if (personal != null && personal?.length == 0) {
                    //   PersonPhone = cellProps.row.original.phonenumber
                    // } else if (personal != null) {
                    //   PersonPhone = personal[0]?.person_phone
                    // }
                    // return <div>{PersonPhone ? PersonPhone : "-"}</div>
                },
            },
            {
                Header: "Source",
                accessor: "source",
                isInfoIcon: true,
                className: "text-center",
            },
            {
                Header: "Days",
                accessor: "updated_at", // this just provides a value for table
                className: "text-center",
                Cell: ({ row }) => {
                    const updatedDate =
                        row.original.last_note_updated_at || row.original.updated_at;

                    if (!updatedDate) return "-";

                    const updated = new Date(updatedDate);
                    const today = new Date();

                    // Convert both to pure dates (no time)
                    const updatedOnly = new Date(
                        updated.getFullYear(),
                        updated.getMonth(),
                        updated.getDate(),
                    );

                    const todayOnly = new Date(
                        today.getFullYear(),
                        today.getMonth(),
                        today.getDate(),
                    );

                    const diffDays = (todayOnly - updatedOnly) / (1000 * 60 * 60 * 24);

                    return diffDays <= 0 ? 0 : diffDays;
                },
            },
            {
                Header: "Status",
                accessor: "status",
                className: "text-start",
                Cell: (cellProps) => {
                    return (
                        <div className="lead-type-popover-wrap">
                            {/* CLICKABLE BADGE */}
                            <div
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleStatusDropdown(cellProps.row.original);
                                }}
                                style={{
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Badge className={cellProps.row.original.status_color}>
                                    {cellProps.row.original.sname}
                                </Badge>
                            </div>

                            {/* DROPDOWN */}
                            {openStatusDropdownId === cellProps.row.original.id && (
                                <div
                                    className="lead-type-popover-box"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {status_option.map((item) => {
                                        const isActive =
                                            cellProps.row.original.lead_status_id === item.value;

                                        return (
                                            <div
                                                key={item.value}
                                                onClick={() =>
                                                    handleStatusChange(
                                                        cellProps.row.original.id,
                                                        item.value,
                                                    )
                                                }
                                                className={`lead-type-option ${isActive ? "active" : ""
                                                    }`}
                                            >
                                                {item.label}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                },
            },
            {
                Header: "Last Reply",
                accessor: "last-reply",
                isInfoIcon: true,
                className: "text-center",
                Cell: ({ row }) => {
                    const date = row?.original?.last_note_date;
                    return <div>{date ? moment(date).format("DD-MM-YYYY") : "-"}</div>;
                },
            },
            {
                Header: "Action",
                accessor: "action",
                Cell: (cellProps) => {
                    const onDeletePermission = async () => {
                        startLoading();
                        const formData = new FormData();
                        formData.append("user_id", localStorage.getItem("auth_id"));
                        formData.append("module_id", 17);
                        try {
                            await axios({
                                method: "post",
                                url: `${configure.apiUrl}/earth_permission`,
                                data: formData,
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                },
                            }).then((res) => {
                                if (res.data.data.india[5] == 1 || res.data.data.uk[5] == 1) {
                                    onDeleteLead();
                                } else {
                                    setAccessDenied(true);
                                }
                                stopLoading();
                            });
                        } catch (error) {
                            console.log(error);
                            stopLoading();
                        }
                    };

                    const onDeleteLead = (e) => {
                        swal({
                            title: "Are you sure?",
                            text: "You want to Delete this Lead !",
                            icon: "warning",
                            buttons: true,
                            dangerMode: true,
                        }).then(async (willDelete) => {
                            if (willDelete) {
                                startLoading();
                                const formEntires = {
                                    id: cellProps.row.original.id,
                                    user_id: localStorage.getItem("auth_id"),
                                };
                                try {
                                    const response = await axios({
                                        method: "post",
                                        url: `${configure.nodeApi}/delete_lead`,
                                        data: formEntires,
                                        headers: {
                                            Accept: "application/json",
                                            "Content-Type": "multipart/form-data",
                                        },
                                    }).then((response) => {
                                        swal({
                                            icon: "success",
                                            text: "Lead Deleted Successfully",
                                        }).then((data) => {
                                            fetch();
                                        });
                                        stopLoading();
                                    });
                                } catch (err) {
                                    swal({
                                        icon: "error",
                                        text: "Something went wrong",
                                    });
                                    stopLoading();
                                }
                            }
                        });
                    };

                    const fetch2 = async (id) => {
                        setCreatedAt(cellProps.row.original.created_at);
                        setViewId(id);
                        startLoading();
                        setmodal_fullscreen(true);
                        const formData = new FormData();
                        formData.append("lead_id", cellProps.row.original.id);
                        formData.append("user_id", localStorage.getItem("auth_id"));
                        try {
                            const response = await axios({
                                method: "post",
                                url: `${configure.apiUrl}/all_lead_data`,
                                data: formData,
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                },
                            }).then((response) => {
                                setLeadData(response.data.data.lead);
                                setNoteData(response.data.data.lead_note);
                                setLogData(response.data.data.lead_activity?.reverse());
                                setFollowData(response.data.data.lead_followup_data);
                                setAssignData(response.data.data?.assigned);
                                console.log(
                                    "Followup Data of lead of",
                                    cellProps.row.original.id,
                                    response.data.data.lead_followup_data,
                                );
                                setViewAssign(
                                    response.data.data.assigned?.map((obj) => ({
                                        value: obj.id,
                                        label: obj.name,
                                    })),
                                );

                                stopLoading();
                            });
                        } catch (err) {
                            console.log(err);
                            stopLoading();
                        }
                    };

                    const fetch3 = async (id) => {
                        setCreatedAt(cellProps.row.original.created_at);
                        // setViewId(id)
                        startLoading();
                        // setmodal_fullscreen(true)
                        const formData = new FormData();
                        formData.append("lead_id", cellProps.row.original.id);
                        formData.append("user_id", localStorage.getItem("auth_id"));
                        try {
                            const response = await axios({
                                method: "post",
                                url: `${configure.apiUrl}/all_lead_data`,
                                data: formData,
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                },
                            }).then((response) => {
                                setLeadData(response.data.data.lead);
                                setNoteData(response.data.data.lead_note);
                                setLogData(response.data.data.lead_activity?.reverse());
                                setFollowData(response.data.data.lead_followup_data);
                                setAssignData(response.data.data?.assigned);
                                console.log(
                                    "Followup Data of lead of",
                                    cellProps.row.original.id,
                                    response.data.data.lead_followup_data,
                                );
                                // setViewAssign(
                                //   response.data.data.assigned?.map(obj => ({
                                //     value: obj.id,
                                //     label: obj.name,
                                //   }))
                                // )

                                stopLoading();
                            });
                        } catch (err) {
                            console.log(err);
                            stopLoading();
                        }
                    };

                    const onConvert = async (e) => {
                        startLoading();
                        const formData = new FormData();
                        formData.append("lead_id", cellProps.row.original.id);
                        try {
                            const response = await axios({
                                method: "post",
                                url: `${configure.apiUrl}/convert_to_customer`,
                                data: formData,
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                },
                            }).then((response) => {
                                swal({
                                    icon: "success",
                                    text: "Converted Successfully",
                                }).then((data) => {
                                    navigate(
                                        `${configure.appUrl}sales/edit-customer/${response.data.data.id}`,
                                    );
                                });

                                stopLoading();
                            });
                        } catch (err) {
                            console.log(err);
                            stopLoading();
                        }
                    };

                    const onEditPermission = async ({ id, isEditType }) => {
                        startLoading();
                        const formData = new FormData();
                        formData.append("user_id", localStorage.getItem("auth_id"));
                        formData.append("module_id", 17);
                        try {
                            await axios({
                                method: "post",
                                url: `${configure.apiUrl}/earth_permission`,
                                data: formData,
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                },
                            }).then((res) => {
                                console.log(
                                    "Country Dataaaaaa",
                                    res.data.data.india,
                                    res.data.data.uk,
                                );
                                if (res.data.data.india[4] == 1 || res.data.data.uk[4] == 1) {
                                    if (isEditType == 1) {
                                        console.log("working");
                                        navigate(`${configure.appUrl}sales/edit-lead/${id}`);
                                    } else {
                                        onConvert();
                                    }
                                } else {
                                    setAccessDenied(true);
                                }
                                stopLoading();
                            });
                        } catch (error) {
                            console.log(error);
                            stopLoading();
                        }
                    };

                    // const copyFon = alldata => {
                    //   let phone = ""

                    //   if (alldata?.person_details) {
                    //     try {
                    //       const parsed = JSON.parse(alldata.person_details)
                    //       if (parsed?.[0]?.person_phone) {
                    //         phone = parsed[0].person_phone
                    //       }
                    //     } catch (e) {
                    //       console.error("Invalid JSON in person_details")
                    //     }
                    //   }

                    //   if (!phone && alldata?.phonenumber != null) {
                    //     phone = alldata.phonenumber
                    //   }

                    //   if (!phone) return

                    //   navigator.clipboard.writeText(phone)

                    //   // setCopiedId(alldata.id);
                    //   // setTimeout(() => setCopiedId(null), 1500);
                    // }

                    const token = secureLocalStorage.getItem("auth_token");
                    const onSendRequest = async () => {
                        const formEntires = {
                            lead_id: cellProps?.row?.original?.id,
                            status: 1,
                        };
                        // const res = await FetchNodePostData(
                        //   setLoading,
                        //   "leadCOPstatus",
                        //   token,
                        //   formEntires
                        // )

                        const res = await axios({
                            method: "post",
                            url: `${configure.nodeApi}/leadCOPstatus`,
                            data: formEntires,
                        });

                        if (res?.data?.success) {
                            Swal.fire({
                                icon: "success",
                                text: "Request has been sent successfully",
                            });
                        }
                    };

                    return (
                        <div className="d-flex">
                            <a
                                title="add note"
                                className="btn btn-sm btn-outline-secondary me-1"
                                onClick={() => {
                                    setIsNote(false);
                                    fetchCurrency(
                                        cellProps.cell?.row?.original.id,
                                        cellProps.cell?.row?.original,
                                    );
                                    // fetchCurrency(cellProps.cell?.row?.original.id)
                                    setLeadId(cellProps.cell?.row?.original.id);
                                }}
                            >
                                <i className="fas fa-file-alt "></i>
                            </a>

                            <a
                                title="add followup"
                                className="btn btn-sm btn-outline-secondary me-1"
                                onClick={() => {
                                    setFollowupSideBar(true);
                                    fetch3(cellProps.cell?.row?.original.id);
                                    // fetchCurrency(
                                    //   cellProps.cell?.row?.original.id,
                                    //   cellProps.cell?.row?.original
                                    // )
                                    // fetchCurrency(cellProps.cell?.row?.original.id)
                                    setLeadId(cellProps.cell?.row?.original.id);
                                }}
                            >
                                <i className="fas fa-calendar-check"></i>
                            </a>

                            <a
                                title="view lead"
                                className="btn btn-sm btn-outline-secondary me-1"
                                onClick={() => fetch2(cellProps.cell?.row?.original.id)}
                            >
                                <i className="fas fa-eye "></i>
                            </a>
                            <UncontrolledDropdown
                                className="dropdown"
                                style={{ width: "29px" }}
                            >
                                <DropdownToggle
                                    className="btn btn-sm btn-outline-secondary w-100"
                                    color="white"
                                >
                                    <i className="mdi mdi-dots-horizontal"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                    <Link
                                        onClick={() =>
                                            onEditPermission({
                                                id: cellProps.cell.row.original.id,
                                                isEditType: 1,
                                            })
                                        }
                                        // to={`${configure.appUrl}sales/edit-lead/${cellProps.cell?.row?.original.id}`}
                                        title="edit lead"
                                        className="dropdown-item"
                                    >
                                        <i className="fas fa-pencil-alt pr-10"></i> Edit Lead
                                    </Link>



                                    {convertBtn ? (
                                        <>
                                            {cellProps.cell?.row?.original?.ctp_status == 4 ? (
                                                <Link
                                                    to={`${configure.appUrl}customer-onboarding/${cellProps.cell?.row?.original?.temp_customer}`}
                                                    className="dropdown-item"
                                                >
                                                    <i className="fas fa-exchange-alt text-success pr-10"></i>{" "}
                                                    Customer Onboarding
                                                </Link>
                                            ) : cellProps.cell?.row?.original?.ctp_status == 0 ? (
                                                <a
                                                    className="dropdown-item"
                                                    onClick={() => onSendRequest()}
                                                >
                                                    <i className="bx bx-log-in-circle text-success pr-10"></i>{" "}
                                                    Request for Invoice
                                                </a>
                                            ) : null}
                                        </>
                                    ) : null}
                                    <a
                                        onClick={() => onDeletePermission()}
                                        className="dropdown-item"
                                        title="delete"
                                    >
                                        <i className="fas fa-trash-alt pr-10 text-danger"></i>{" "}
                                        Delete Lead
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        title="Create a meeting"
                                        // onClick={() => {
                                        //   redirectCalender()
                                        // }}
                                        href={`${configure.appUrl}calender/lead-${cellProps.cell.row.original.id}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <i className="fa fa-users me-2"></i>
                                        Add Meeting
                                    </a>

                                    <Link
                                        to={`${configure.appUrl}request-for-proposal/${cellProps.cell?.row?.original?.id}`}
                                        className="dropdown-item"
                                    >
                                        <i className="fas fa-exchange-alt text-success pr-10"></i>{" "}
                                        Request For Proposal
                                    </Link>

                                    <a
                                        className="dropdown-item"
                                        title="create task"
                                        onClick={() => {
                                            setLeadId(cellProps.cell?.row?.original.id);
                                            setAddTaskModal(true);
                                        }}
                                    >
                                        <i className="fas fa-tasks pr-10"></i>{" "}
                                        Create Task
                                    </a>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            {cellProps.row.original.mautic == 1 &&
                                cellProps.row.original.is_valid == 1 && (
                                    <div className="d-flex justify-content-center ps-1 align-items-center">
                                        <img
                                            src={mauticImg}
                                            width={23}
                                            height={23}
                                            alt="mautic"
                                            className="img-fluid"
                                        />
                                    </div>
                                )}
                        </div>
                    );
                },
            },
        ],
        [
            convertBtn,
            openLeadTypeDropdownId,
            openStatusDropdownId,
            status_option,
            currentPage,
            limit,
            currentFilters,
            copy,
        ],
    );

    const [formPopup, setFormPopup] = useState(false);
    const [fixedContent, setFixedContent] = useState(false);

    const navigate = useNavigate();

    document.addEventListener("scroll", () => {
        if (window.scrollY > 165) {
            setFixedContent(true);
        } else {
            setFixedContent(false);
        }
    });

    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        setPageSize,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: 0,
            },
        },
        useGlobalFilter,
        usePagination,
    );

    useEffect(() => setPageSize(50), []);

    const colourStyles = {
        menuList: (styles) => ({
            ...styles,
            background: "white",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 1200,
        }),
    };

    useEffect(() => {
        fetchAllData();
        fetchCountry();
    }, []);

    const fetchCountry = async () => {
        startLoading();
        try {
            await axios({
                method: "get",
                url: `${configure.apiUrl}/locations`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then((res) => {
                setLocation(
                    res.data.data.map((obj) => ({
                        label: obj.location,
                        value: obj.id,
                    })),
                );
                stopLoading();
            });
        } catch (error) {
            console.log(error);
            stopLoading();
        }
    };

    // const onFilter = async e => {
    //   e.preventDefault()
    //   setFormPopup(false)
    //   startLoading()
    //   const Assign = assign.map(obj => obj.value).join(",")
    //   const Status = status.map(obj => obj.value).join(",")
    //   const Source = source.map(obj => obj.value).join(",")
    //   const Type = type.map(obj => obj.label).join(",")
    //   const Industry = industry.map(obj => obj.value).join(",")
    //   const formData = new FormData()
    //   formData.append("user_id", localStorage.getItem("auth_id"))
    //   if (country.value != undefined) {
    //     formData.append("location", country.value)
    //   } else {
    //     formData.append("location", "")
    //   }
    //   formData.append("asigned", Assign)
    //   formData.append("status", Status)
    //   formData.append("source", Source)
    //   formData.append("lead_type", Type)
    //   formData.append("industry", Industry)

    //   try {
    //     const response = await axios({
    //       method: "post",
    //       url: `${configure.nodeApi}/all_lead`,
    //       data: formData,
    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "multipart/form-data",
    //       },
    //     }).then(response => {
    //       setDatas(response.data.data)
    //       stopLoading()
    //     })
    //   } catch (err) {
    //     console.log(err)
    //     stopLoading()
    //   }
    // }

    const onFilter = async (e, lead_type = null) => {
        if (e) e.preventDefault();
        setFormPopup(false);
        startLoading();

        const Assign = assign.map((obj) => obj.value).join(",");
        const Status = status.map((obj) => obj.value).join(",");
        const Source = source.map((obj) => obj.value).join(",");
        const Type = lead_type || type.map((obj) => obj.label).join(","); // or .value if needed
        const Industry = industry.map((obj) => obj.value).join(",");

        const newFilters = {
            location: country?.value || "",
            asigned: Assign,
            status: Status,
            source: Source,
            lead_type: Type,
            industry: Industry,
            keyword: "",
        };

        setCurrentFilters(newFilters); // Save filters
        await fetch(1, limit, "", newFilters); // Reset to page 1
        stopLoading();
    };

    const [title, setTitle] = useState("");

    const info = [
        {
            title: "Assigned",
            mean: " <p> <strong>Meaning :</strong> In the Mars System's Lead Module, the <strong>Assigned</strong> column designates the specific team member or individual responsible for overseeing and taking action on a lead or potential business opportunity. </p>",
            purpose:
                " <p> <strong>Purpose :</strong> The purpose of the <strong>Assigned</strong> column in the Lead Module is to assign clear accountability for each lead. By identifying who is responsible for nurturing and converting leads into customers, it streamlines lead management, ensures follow-up, and enhances the chances of successful lead conversion. This fosters a more efficient and organized approach to lead handling within the Mars System.</p>",
        },
        {
            title: "Company",
            mean: "<p><strong>Meaning :</strong>  Within the Mars System's Lead Module, the <strong>Company</strong> column refers to the name of the organization or business entity associated with a lead or potential opportunity</p>",
            purpose:
                "<p> <strong>Purpose :</strong> The purpose of the <strong>Company</strong> column is to provide crucial information about the lead's affiliation. It helps in categorizing leads by their company, allowing sales and marketing teams to tailor their strategies and messaging accordingly. This column streamlines lead segmentation and ensures that leads from the same company are managed cohesively, enhancing the effectiveness of lead conversion efforts.</p>",
        },
        {
            title: "Name",
            mean: "<p><strong>Meaning :</strong>  In the Mars System's Lead Module, the <strong>Name</strong> column typically represents the full name of an individual associated with a lead or potential business opportunity.. </p>",
            purpose:
                "</strong> <p> <strong>Purpose :</strong> The purpose of the <strong>Name</strong> column is to provide specific information about the person linked to the lead. It allows for personalized communication and relationship-building with leads. By knowing the names of potential clients or contacts, the Mars System's users can establish a more personal and targeted approach to lead engagement, which can significantly improve lead conversion rates and customer satisfaction</p>",
        },
        {
            title: "Email ID",
            mean: "<p><strong>Meaning :</strong>  Within the Mars System's Lead Module, the <strong>Email ID</strong> column stores the email addresses of individuals or contacts associated with leads or potential business opportunities</p>",
            purpose:
                "<p><strong>Purpose :</strong> The purpose of the <strong>Email ID</strong> column is to serve as a primary means of communication with leads. Email addresses are crucial for sending follow-up messages, marketing materials, and other relevant information. This column ensures that users have a direct and reliable channel to reach out to leads, fostering efficient communication and nurturing relationships to move leads further down the sales funnel.</p>",
        },
        {
            title: "Phone",
            mean: "<p><strong>Meaning :</strong>  In the Mars System's Lead Module, the <strong>Phone</strong> column contains the contact phone numbers of individuals or organizations associated with leads or potential business opportunities</p>",
            purpose:
                "<p><strong>Purpose :</strong> The purpose of the <strong>Phone</strong> column is to provide an additional means of direct communication with leads. Phone numbers enable users to engage with leads through voice calls, which can be especially effective for personalized interactions, follow-ups, and addressing specific inquiries. This column enhances the versatility of communication channels, allowing for more comprehensive lead engagement and relationship building.</p>",
        },
        {
            title: "Days",
            mean: " <p><strong>Meaning :</strong>  In the Mars System's Lead Module, the <strong>Days</strong> column signifies the number of days that have elapsed since the lead's last update or entry into the system.</p>",
            purpose:
                "<p><strong>Purpose :</strong> The purpose of the <strong>Days</strong> column is to provide a time-based reference for lead activity. It helps users understand the recency of lead updates, ensuring that leads are regularly reviewed and actioned upon. This column aids in prioritizing leads that require immediate attention, as leads with longer durations since their last update may need follow-ups or reevaluation. It promotes timely and effective lead management within the Mars System.</p>",
        },
        {
            title: "Status",
            mean: "<p><strong>Meaning :</strong>  In the Mars System's Lead Module, the <strong>Status</strong> column indicates the current stage or status of a lead's progression within the lead management process</p>",
            purpose:
                "<p><strong>Purpose :</strong>  The purpose of the  <strong>Status</strong> column is to provide a clear overview of where each lead stands in the sales or conversion pipeline. It allows users to track and manage leads efficiently by categorizing them into stages such as  <strong>New </strong> ,  <strong>Contacted </strong>,  <strong>Qualified </strong>,  <strong>Negotiating </strong>, or  <strong>Closed</strong>. This status tracking facilitates better lead prioritization, workflow management, and decision-making, helping teams focus their efforts on leads at the appropriate stage of the sales cycle.</p>",
        },
    ];

    const [modal_Access, setAccessDenied] = useState(false);

    // Quick Note Functionality

    const [currency_option, setCurrencyOption] = useState([]);
    const [allNotes, setAllNotes] = useState([]);
    const [lead_id, setLeadId] = useState("");
    const [leadDetail, setLeadDetail] = useState({});
    // const toggleLoading = loading => {
    //   setLoading(loading)
    // }

    const fetchCurrency = async (id, obj) => {
        setIsNote(false);
        setNotesSidebar(true);
        const personal = JSON?.parse(obj?.person_details);
        let PersonName;
        if (personal != null && personal?.length == 0) {
            PersonName = "-";
        } else if (personal != null) {
            PersonName = personal[0]?.person_name;
        }
        const newObj = { ...obj, personName: PersonName };
        setLeadDetail(newObj);
        // const response = await fetchData(toggleLoading, `leadNotesData/${id}`, "")
        const response = await axios({
            method: "get",
            url: `${configure.apiUrl}/leadNotesData/${id}`,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
            },
        });
        console.log("res: ", response.data);
        if (response?.data?.success) {
            setCurrencyOption(
                response?.data?.data.currency.map((item) => ({
                    label: item.currency,
                    value: item.id,
                })),
            );
            console.log("response.data.notes: ", response?.data?.data.notes);
            setAllNotes(response?.data.data.notes);
        }
    };

    const [selectedFiles1, setselectedFiles1] = useState([]);

    function handleAcceptedFiles1(files) {
        files.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size),
            }),
        );
        setselectedFiles1(files);
    }

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    const [notesSidebar, setNotesSidebar] = useState(false);
    const [followupSidebar, setFollowupSideBar] = useState(false);

    const [currency, setCurrency] = useState({
        label: null,
        value: null,
    });
    const curentDateTime = moment().format("YYYY-MM-DDTHH:mm");
    const [notedate, setNotedate] = useState(curentDateTime);
    // const [assign, setAssigned] = useState([])
    const [amount, setAmount] = useState("");
    const [ckedata, setCkedata] = useState("");
    const [noDrag, setNoDrag] = useState(false);
    const [noteForm, setNoteForm] = useState(false);
    const [boxWidth, setBoxWidth] = useState(0);
    const [boxHeight, setBoxHeight] = useState(0);

    useEffect(() => {
        const updateWidth = () => {
            const viewportWidth = window.innerWidth;
            setBoxWidth(viewportWidth * 0.9);
        };
        const updateHeight = () => {
            const viewpoirtHeight = window.innerHeight;
            setBoxHeight(viewpoirtHeight * 0.7);
        };
        updateHeight();
        updateWidth();
        window.addEventListener("resize", updateWidth, updateHeight);
        return () =>
            window.removeEventListener("resize", updateWidth, updateHeight);
    }, []);

    // add notes api
    const addNotes = async (e) => {
        e.preventDefault();
        // 🔥 Confirmation popup
        const resultConfirm = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to add this Note?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#6f42c1",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, add it!",
        });

        if (!resultConfirm.isConfirmed) return;

        startLoading();
        const formData = new FormData();

        if (isNote) {
            formData.append("related_id", lead_id);
            formData.append("related_to", "lead");
            formData.append("related", "sales");
            formData.append("type", 2);
            formData.append("copynotes", true);
            formData.append("title", taskName);
            formData.append("priority", priority.value);
            formData.append("assigned", assignee.value);
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("description", ckedata);
            formData.append("currency", currency.value != null ? currency.value : "");
            formData.append("date", notedate);
            formData.append("amount", amount);
        } else {
                formData.append("lead_id", lead_id);
                formData.append("user_id", localStorage.getItem("auth_id"));
                formData.append("currency", currency.value != null ? currency.value : "");
                formData.append("date", notedate);
                formData.append("amount", amount);
                formData.append("description", ckedata);
            }
            for (let i = 0; i < selectedFiles1.length; i++) {
                formData.append("files[]", selectedFiles1[i]);
            }
        try {
            if (isNote) {
                const response = await axios({
                    method: "post",
                    url: `${configure.apiUrl}/addGeneralTasks`,
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                });
                console.log("response: ", response);
                if (response) {
                    stopLoading();
                    Swal.fire({
                        icon: "success",
                        text: "Task & Note Added Successfully",
                    }).then((data) => {
                        setCkedata("");
                        setAmount("");
                        setNotesSidebar(false);
                        setIsNote(false);
                        setTaskName("");
                        setPriority([]);
                        setAssignee([]);
                        setCurrency({
                            label: null,
                            value: null,
                        });
                        setNotedate([]);
                        setselectedFiles1([]);
                        fetch();
                    });
                }
            } else {
                const response = await axios({
                    method: "post",
                    url: `${configure.nodeApi}/add_lead_note`,
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                });

                const resData = response.data;
                stopLoading();

                if (resData.success === false && resData.ai_blocked === true) {
                    const result = await Swal.fire({
                        icon: "warning",
                        title: "Quality Check Failed",
                        html: `<p>${resData.message}</p><br/><small style="color:#666">${resData.ai_feedback}</small>`,
                        showCancelButton: true,
                        confirmButtonText: "Save Anyway",
                        cancelButtonText: "Go Back & Edit",
                        confirmButtonColor: "#f39c12",
                    });

                    if (result.isConfirmed) {
                        formData.append("ai_override", "true");
                        startLoading();
                        await axios({
                            method: "post",
                            url: `${configure.nodeApi}/add_lead_note`,
                            data: formData,
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "multipart/form-data",
                            },
                        });
                        stopLoading();
                        Swal.fire({
                            icon: "success",
                            text: "Note Added Successfully",
                        }).then(() => {
                            setCkedata("");
                            setAmount("");
                            setNotedate(curentDateTime);
                            setCurrency({ label: null, value: null });
                            setselectedFiles1([]);
                            fetch();
                            setNotesSidebar(false);
                        });
                    }
                } else {
                    Swal.fire({
                        icon: "success",
                        text: "Note Added Successfully",
                    }).then(() => {
                        setCkedata("");
                        setAmount("");
                        setNotedate(curentDateTime);
                        setCurrency({ label: null, value: null });
                        setselectedFiles1([]);
                        fetch();
                        setNotesSidebar(false);
                    });
                }
            }
        } catch (error) {
            console.log(error);
            stopLoading();
        }
    };

    // const addFollowup = async e => {
    //   e.preventDefault()
    //   // setLoading(true)
    //   const result = assign?.map(obj => obj.value).join(",")
    //   const formData = new FormData()
    //   formData.append("lead_id", lead_id)
    //   formData.append("user_id", localStorage.getItem("auth_id"))
    //   formData.append("note_id", 0)
    //   formData.append("assign_user", result)
    //   formData.append("date", notedate)
    //   formData.append("description", description)
    //   try {
    //     const response = await axios({
    //       method: "post",
    //       url: `${configure.apiUrl}/add_followup`,
    //       data: formData,
    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "multipart/form-data",
    //       },
    //     }).then(response => {
    //       setDatas(response.data.data)
    //       setNotesSidebar(false)
    //       setFollowupSideBar(false)
    //       // setLoading(false)
    //       setDescription("")
    //       setNotedate("")
    //       setAssign([])
    //     })
    //   } catch (error) {
    //     console.log(error)
    //     // setLoading(false)
    //   }
    // }

    const addFollowup = async (e) => {
        e.preventDefault();

        // 🔥 Confirmation popup
        const resultConfirm = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to add this followup?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#6f42c1",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, add it!",
        });

        if (!resultConfirm.isConfirmed) return;

        try {
            const result = assign?.map((obj) => obj.value).join(",");

            const formData = new FormData();
            formData.append("lead_id", lead_id);
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("note_id", 0);
            formData.append("assign_user", result);
            formData.append("date", notedate);
            formData.append("description", description);

            const response = await axios.post(
                `${configure.apiUrl}/add_followup`,
                formData,
            );

            if (response?.data) {
                setDatas(response.data.data || []);
            }

            // ✅ Success popup
            Swal.fire({
                icon: "success",
                title: "Added!",
                text: "Followup added successfully.",
                timer: 1500,
                showConfirmButton: false,
            });

            setFollowupSideBar(false);
            setDescription("");
            setNotedate("");
            setAssign([]);
            fetch();
        } catch (error) {
            console.error("API ERROR:", error?.response?.data || error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong while adding followup.",
            });
        }
    };

    const onSaveFilter = async (e) => {
        startLoading();
        const Assign = assign?.map((obj) => obj.value).join(",");
        const Status = status?.map((obj) => obj.value).join(",");
        const Source = source?.map((obj) => obj.value).join(",");
        const Type = type?.map((obj) => obj.value).join(",");
        const Industry = industry?.map((obj) => obj.value).join(",");
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("location", country?.value);
        formData.append("assigned", Assign);
        formData.append("status", Status);
        formData.append("source", Source);
        formData.append("lead_type", Type);
        formData.append("industry", Industry);
        try {
            const response = await axios({
                method: "post",
                url: `${configure.apiUrl}/save_lead_filter`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then((response) => {
                swal({
                    icon: "success",
                    text: "Filters Saved Successfully",
                });
                setDiable(!disable);
                stopLoading();
            });
        } catch (err) {
            console.log(err);
            stopLoading();
        }
    };

    const onClearFilter = async (e) => {
        setLeadType("");
        startLoading();
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        try {
            const response = await axios({
                method: "post",
                url: `${configure.apiUrl}/clear_lead_filter`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then((response) => {
                swal({
                    icon: "success",
                    text: "Filters Cleared Successfully",
                }).then(async (data) => {
                    setCurrentFilters({
                        location: "",
                        asigned: "",
                        status: "",
                        source: "",
                        lead_type: "",
                        industry: "",
                        keyword: "",
                    });
                    setCountry("");
                    setSource([]);
                    setStatus([]);
                    setAssign([]);
                    setType([]);
                    setIndustry([]);
                    await fetch(1, 50, "", {
                        location: "",
                        asigned: "",
                        status: "",
                        source: "",
                        lead_type: "",
                        industry: "",
                        keyword: "",
                    });
                    console.log("callingFetch");
                    setDiable(!disable);
                });
                stopLoading();
            });
        } catch (err) {
            console.log(err);
            stopLoading();
        }
    };

    const timeDifference = new Date() - new Date(created_at);
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    const onAddPermission = async (id) => {
        startLoading();
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("module_id", 17);
        try {
            await axios({
                method: "post",
                url: `${configure.apiUrl}/earth_permission`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then((res) => {
                if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
                    navigate(`${configure.appUrl}sales/add-lead`);
                } else {
                    setAccessDenied(true);
                }
                stopLoading();
            });
        } catch (error) {
            console.log(error);
            stopLoading();
        }
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [country, source, status, assign, type, industry]);

    const handleSearch = (value) => {
        fetch(1, 50, value, currentFilters);
    };

    const debouncedSearch = React.useMemo(() => debounce(handleSearch, 600), []);

    const [taskName, setTaskName] = useState("");
    const [priority, setPriority] = useState([]);
    const [assignee, setAssignee] = useState([]);
    const [alldependency, setAllDependency] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [addTaskModal, setAddTaskModal] = useState(false);

    const fetchAllData = async () => {
        const authToken = secureLocalStorage.getItem("auth_token");
        // const datas = await fetchData(toggleLoading, "generalData", authToken)
        const datas = await axios({
            method: "get",
            url: `${configure.apiUrl}/generalData`,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
            },
        });
        console.log("datas: ", datas?.data?.data);
        setAllDependency(transformGeneralData(datas?.data?.data));
        setTasks(
            datas?.data?.data?.subtasks?.map((obj) => ({
                id: obj.task,
                related: obj.related,
                subtasks: obj.subtasks,
                value: obj.task,
                label: obj.task,
            })),
        );
    };

    function debounce(func, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => func(...args), delay);
        };
    }

    const countsData = useMemo(() => {
        return [
            {
                title: "Hot",
                count: hotCount,
            },
            {
                title: "Warm",
                count: warmCount,
            },
            {
                title: "Cold",
                count: coldCount,
            },
            {
                title: "Normal",
                count: normalCount,
            },
        ];
    }, [hotCount, warmCount, coldCount, normalCount]);

    function filterByType(lead_type) {
        if (!leadType || leadType !== lead_type) {
            setLeadType(lead_type);
            onFilter(null, lead_type);
            //   fetch(1, limit, "", { lead_type });
            // await fetch(1, limit, "", newFilters); // Reset to page 1
        } else {
            setLeadType("");
            onFilter(null);
        }
    }

    return (
        <React.Fragment>
            {/* {isLoading && <Loader />} */}
            {loadingCounter > 0 && <Loader />}
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="Dashboard"
                        breadcrumbItem="Lead"
                        englishVideo="https://zithastechnologiespvtltd695-my.sharepoint.com/:v:/g/personal/earthdesk_zithas_com/EWWbgyc5YpVGp-3zgYtrmswB28AYPFDqnt1mbQpcUxURKg?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D&e=VTLlRp&download=1"
                        hindiVideo="https://zithastechnologiespvtltd695-my.sharepoint.com/:v:/g/personal/earthdesk_zithas_com/EWWbgyc5YpVGp-3zgYtrmswB28AYPFDqnt1mbQpcUxURKg?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D&e=VTLlRp&download=1"
                    />

                    <Row>
                        <Col lg={12} className="p-0">
                            <Card>
                                <CardBody>
                                    <div className="responsive-table">
                                        <div>
                                            <div
                                                className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
                                                    }`}
                                            >
                                                <Link
                                                    onClick={() => onAddPermission()}
                                                    className="btn btn-purple  fix-btn btn-label pe-0"
                                                >
                                                    <i className="fas fa-plus me-2 icon-size label-icon"></i>
                                                    <span>Lead</span>
                                                </Link>
                                                <button
                                                    onClick={() => navigate(-1)}
                                                    className="btn btn-red  fix-btn btn-label pe-0"
                                                >
                                                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                                    <span>Cancel</span>
                                                </button>
                                            </div>
                                            <Row className="mb-2">
                                                <Col xs="auto d-flex align-items-center">
                                                    <div className="d-flex">
                                                        {/* <select
                              className=" form-select"
                              style={{ width: "100px" }}
                              value={pageSize}
                              onChange={e => setPageSize(e.target.value)}
                            >
                              {[10, 25, 50, 100].map(pageSize => (
                                <option key={pageSize} value={pageSize}>
                                  Show {pageSize}
                                </option>
                              ))}
                            </select> */}
                                                        <select
                                                            className="form-select"
                                                            style={{ width: "100px" }}
                                                            value={limit}
                                                            onChange={(e) => {
                                                                setLimit(Number(e.target.value));
                                                                fetch(1, Number(e.target.value)); // reset to first page
                                                            }}
                                                        >
                                                            {[10, 25, 50, 100].map((size) => (
                                                                <option key={size} value={size}>
                                                                    Show {size}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col
                                                    xs="auto"
                                                    className="align-items-center d-flex fs-5"
                                                >
                                                    <div className="d-flex justify-content-start gap-3">
                                                        {countsData.map((tab) => (
                                                            <a
                                                                key={tab.title}
                                                                className={`d-flex gap-2 align-items-center general-box ${leadType === tab.title && "bg-purple"
                                                                    }`}
                                                                onClick={() => filterByType(tab.title)}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={leadType === tab.title}
                                                                    style={{ accentColor: "white" }}
                                                                />
                                                                <h5 className="text-purple mb-0">
                                                                    {tab.title} :{" "}
                                                                </h5>
                                                                <h5 className="text-primary mb-0">
                                                                    {tab.count}
                                                                </h5>
                                                            </a>
                                                        ))}
                                                        <a className="d-flex gap-3 align-items-center general-box bg-light-red">
                                                            <h5 className="text-danger mb-0">Proposal : </h5>
                                                            <h5 className="text-danger mb-0">
                                                                {
                                                                    data?.filter(
                                                                        (obj) =>
                                                                            obj?.sname?.toLowerCase() == "proposal" &&
                                                                            obj?.lead_type != "Cold",
                                                                    )?.length
                                                                }
                                                            </h5>
                                                        </a>
                                                    </div>
                                                </Col>
                                                <Col className="d-flex justify-content-end">
                                                    <div className="me-2 col">
                                                        <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                                                            <div className="position-relative">
                                                                <label
                                                                    htmlFor="search-bar-0"
                                                                    className="search-label"
                                                                >
                                                                    <span
                                                                        id="search-bar-0-label"
                                                                        className="sr-only"
                                                                    >
                                                                        Search this table
                                                                    </span>
                                                                    <input
                                                                        onChange={(e) => {
                                                                            debouncedSearch(e.target.value);
                                                                        }}
                                                                        id="search-bar-0"
                                                                        type="text"
                                                                        className="form-control rounded h-100"
                                                                        placeholder={
                                                                            fullLeadLoading
                                                                                ? "Loading search engine..."
                                                                                : "Search..."
                                                                        }
                                                                    />
                                                                </label>
                                                                <i className="bx bx-search-alt search-icon"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button
                                                            onClick={() => setFormPopup(!formPopup)}
                                                            className="btn btn-outline-secondary  me-3"
                                                        >
                                                            <i className="fas fa-filter"></i>
                                                        </button>
                                                    </div>
                                                    <div className="text-md-end col">
                                                        <Link
                                                            id="add"
                                                            onClick={() => onAddPermission()}
                                                            className=" btn text-white me-2 btn-save btn-label"
                                                        >
                                                            <i className="fas fa-plus me-2 icon-size label-icon"></i>
                                                            Lead
                                                        </Link>
                                                        <button
                                                            onClick={() => navigate(-1)}
                                                            className=" btn btn-red  btn-label"
                                                        >
                                                            <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                                            CANCEL
                                                        </button>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="position-relative">
                                                <Table
                                                    className="table table-bordered mt-4"
                                                    {...getTableProps()}
                                                >
                                                    <thead
                                                        className={`${fixedContent ? "fix-header" : ""
                                                            } fix-lead-header`}
                                                    >
                                                        {headerGroups.map((headerGroup, i) => (
                                                            <tr
                                                                key={i}
                                                                {...headerGroup.getHeaderGroupProps()}
                                                            >
                                                                {headerGroup.headers.map((column, index) => (
                                                                    <th
                                                                        key={index}
                                                                        className={`t-col-${index + 1} ${column.className
                                                                            }`}
                                                                        {...column.getHeaderProps()}
                                                                    >
                                                                        {column.render("Header")}
                                                                        {column.isInfoIcon ? (
                                                                            <a
                                                                                onClick={() => {
                                                                                    setNameModal(true);
                                                                                    setTitle(column.Header);
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    title="info"
                                                                                    className={`bx bx-info-circle ms-1 info-icon assign-${index}`}
                                                                                ></i>
                                                                            </a>
                                                                        ) : null}
                                                                    </th>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </thead>

                                                    <tbody
                                                        className="fix-lead-header"
                                                        {...getTableBodyProps()}
                                                    >
                                                        {page.map((row, i) => {
                                                            prepareRow(row);
                                                            let backColor;
                                                            if (row.original.lead_type == "Hot") {
                                                                backColor = "bd-hot";
                                                            }
                                                            return (
                                                                <tr
                                                                    className={`row-hover ${backColor}`}
                                                                    {...row.getRowProps()}
                                                                    key={i}
                                                                >
                                                                    {row.cells.map((cell, index) => {
                                                                        return (
                                                                            <td
                                                                                key={index}
                                                                                onClick={() =>
                                                                                    cell.column.Header === "Company"
                                                                                        ? navigate(
                                                                                            `${configure.appUrl}sales/edit-lead/${cell.row.allCells[0].value}`,
                                                                                        )
                                                                                        : ""
                                                                                }
                                                                                className={`t-col-${index + 1} ${cell.column.className
                                                                                    }`}
                                                                                {...cell.getCellProps()}
                                                                            >
                                                                                {cell.render("Cell")}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            );
                                                        })}
                                                        {page.length == 0 ? (
                                                            <tr>
                                                                <td className="text-center" colSpan={11}>
                                                                    No Leads Available
                                                                </td>
                                                            </tr>
                                                        ) : null}
                                                    </tbody>
                                                </Table>

                                                {formPopup ? (
                                                    <div className="popup-form p-4">
                                                        <Form onSubmit={onFilter}>
                                                            <Row className="align-items-end">
                                                                <Row
                                                                    className="d-flex pe-0 me-0"
                                                                    style={{ width: "100%" }}
                                                                >
                                                                    <div className="col-md-3 mb-2">
                                                                        <label htmlFor="">Location</label>
                                                                        <Select
                                                                            placeholder="Select Location"
                                                                            className="basic-multi-select"
                                                                            classNamePrefix=" select"
                                                                            onChange={(e) => setCountry(e)}
                                                                            value={country}
                                                                            styles={colourStyles}
                                                                            options={location}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 mb-2">
                                                                        <label htmlFor="">Source</label>
                                                                        {country.value == "2" ? (
                                                                            <Select
                                                                                placeholder="Select Source"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={sourceuk_option}
                                                                                value={source}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setSource(e)}
                                                                            />
                                                                        ) : country.value == "1" ? (
                                                                            <Select
                                                                                placeholder="Select Source"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={sourceIn_option}
                                                                                value={source}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setSource(e)}
                                                                            />
                                                                        ) : (
                                                                            <Select
                                                                                placeholder="Select Source"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={allsource_option}
                                                                                value={source}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setSource(e)}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-3 mb-2">
                                                                        <label htmlFor="">Status</label>
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            className="basic-multi-select"
                                                                            classNamePrefix=" select"
                                                                            styles={colourStyles}
                                                                            options={status_option}
                                                                            value={status}
                                                                            closeMenuOnSelect={false}
                                                                            isMulti
                                                                            onChange={(e) => setStatus(e)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 mb-2">
                                                                        <label htmlFor="">Assigned</label>
                                                                        {country.value == "2" ? (
                                                                            <Select
                                                                                placeholder="Select Assigned"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={useruk_option}
                                                                                value={assign}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setAssign(e)}
                                                                            />
                                                                        ) : country.value == "1" ? (
                                                                            <Select
                                                                                placeholder="Select Assigned"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={userIn_option}
                                                                                value={assign}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setAssign(e)}
                                                                            />
                                                                        ) : (
                                                                            <Select
                                                                                placeholder="Select Assigned"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={alluser_option}
                                                                                value={assign}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setAssign(e)}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-3 mt-2">
                                                                        <label htmlFor="">Lead Type</label>
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            className="basic-multi-select"
                                                                            classNamePrefix=" select"
                                                                            styles={colourStyles}
                                                                            options={type_option}
                                                                            closeMenuOnSelect={false}
                                                                            value={type}
                                                                            onChange={(e) => setType(e)}
                                                                            isMulti
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 mt-2">
                                                                        <label htmlFor="">Industry</label>
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            className="basic-multi-select"
                                                                            classNamePrefix=" select"
                                                                            styles={colourStyles}
                                                                            options={industry_option}
                                                                            closeMenuOnSelect={false}
                                                                            value={industry}
                                                                            onChange={(e) => setIndustry(e)}
                                                                            isMulti
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 mt-2">
                                                                        <label htmlFor="">
                                                                            Save and Clear Filters
                                                                        </label>
                                                                        <div>
                                                                            <a
                                                                                className="btn  btn-primary mr-10"
                                                                                onClick={onSaveFilter}
                                                                                style={{
                                                                                    fontSize: "11px",
                                                                                    backgroundColor: "#93a6ff",
                                                                                    borderColor: "#93a6ff",
                                                                                    color: "black",
                                                                                }}
                                                                            >
                                                                                Save Filters
                                                                            </a>
                                                                            <a
                                                                                className="btn  btn-danger"
                                                                                onClick={onClearFilter}
                                                                                style={{
                                                                                    fontSize: "11px",
                                                                                    backgroundColor: "#fed36d",
                                                                                    borderColor: "#fed36d",
                                                                                    color: "black",
                                                                                }}
                                                                            >
                                                                                Clear Filters
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex col-md-3 align-items-end justify-content-end">
                                                                        <div className="mr-10">
                                                                            <button className="btn  btn-purple">
                                                                                <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                                                                                Filter
                                                                            </button>
                                                                        </div>
                                                                        <div className="">
                                                                            <a
                                                                                className="btn  btn-red"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    setDatas(displayData);
                                                                                    setFormPopup(!formPopup);
                                                                                }}
                                                                            >
                                                                                <i className="dripicons-cross me-1 icon-center"></i>{" "}
                                                                                Close
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </Row>
                                                            </Row>
                                                        </Form>
                                                        <i className="bi bi-triangle-fill pop-icon"></i>
                                                    </div>
                                                ) : null}
                                            </div>
                                            <Row className="justify-content-md-end justify-content-center align-items-center">
                                                <ServerPagination
                                                    currentPage={currentPage}
                                                    pageSize={limit}
                                                    totalItems={total}
                                                    onPageChange={async (newPage) => {
                                                        startLoading(); // optional but recommended
                                                        await fetch(newPage, limit, "", currentFilters);
                                                        stopLoading();
                                                    }}
                                                />
                                            </Row>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* View Modal */}
            <Modal size="xl" isOpen={modal_fullscreen} className="modal-fullscreen">
                <div className="modal-header mb-0">
                    <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ width: "100%" }}
                    >
                        <div className="col-6 d-flex align-items-center">
                            <h5 className=" modal-title mt-0">Lead Details</h5>
                            <span
                                className="ml-70 pl-50"
                                style={{ fontSize: "16px", color: "black" }}
                            >
                                Created On : {moment(created_at).format("DD-MM-YYYY")} (
                                {parseFloat(daysDifference).toFixed(0)})
                            </span>
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={() => {
                            setmodal_fullscreen(false);
                        }}
                        className="ms-4"
                        style={{ border: "none", backgroundColor: "transparent" }}
                    >
                        <span
                            aria-hidden="true"
                            style={{ color: "#bf1e30", fontSize: "28px", lineHeight: "1px" }}
                        >
                            {" "}
                            &times;{" "}
                        </span>
                    </button>
                </div>

                <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
                    <Row className="gx-4 justify-content-between">
                        <Col md="2" className="side-tab h-100 py-3 bd-fixed-sidetab">
                            <Nav pills className="flex-column">
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "1",
                                        })}
                                        onClick={() => {
                                            toggleVertical("1");
                                        }}
                                    >
                                        Profile
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "2",
                                        })}
                                        onClick={() => {
                                            toggleVertical("2");
                                        }}
                                    >
                                        Notes
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "4",
                                        })}
                                        onClick={() => {
                                            toggleVertical("4");
                                        }}
                                    >
                                        Follow Up
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "3",
                                        })}
                                        onClick={() => {
                                            toggleVertical("3");
                                        }}
                                    >
                                        Activity Log
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                        <Col md="10" className="bd-right-side-tab">
                            <div className="px-4 h-100 pl-0">
                                <TabContent
                                    activeTab={verticalActiveTab}
                                    className="text-muted mt-4 mt-md-0"
                                >
                                    <TabPane tabId="1">
                                        <ViewProfile viewData={lead_data[0]} />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <ViewNotes
                                            notesData={note_data}
                                            view_assign={view_assign}
                                            viewId={viewId}
                                            verticalActiveTab={verticalActiveTab}
                                        />
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <ViewActivity logData={log_data} />
                                    </TabPane>
                                    <TabPane tabId="4">
                                        <ViewFollowUp
                                            followData={follow_data}
                                            view_assign={view_assign}
                                        />
                                    </TabPane>
                                </TabContent>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal>

            <Modal
                isOpen={name_modal}
                toggle={() => {
                    tog_center();
                }}
                className="bd-info-popup"
                centered
            >
                <div className="modal-header bd-head-info">
                    <h5 className="modal-title mt-0">
                        <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
                        {title}
                    </h5>
                </div>
                <div className="modal-body pb-0">
                    <div className="d-flex">
                        <div className="col-5 pr-30">
                            <div>
                                <img src={InfoGif} className="w-100" />
                            </div>
                        </div>
                        <div className="mt-20 ">
                            <div>
                                {info.map((item) => {
                                    if (item.title == title) {
                                        return (
                                            <>
                                                <span>
                                                    <span
                                                        dangerouslySetInnerHTML={{ __html: item.mean }}
                                                    ></span>
                                                </span>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: item.purpose }}
                                                ></div>
                                            </>
                                        );
                                    }
                                })}
                                <div className="text-center mt-70">
                                    <button
                                        type="button"
                                        className="btn btn-success "
                                        onClick={() => setNameModal(false)}
                                    >
                                        I Understood
                                        <i className="dripicons-thumbs-up pl-10"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <AccessDeniedPopup
                modal_Access={modal_Access}
                setAccessDenied={setAccessDenied}
            />

            {/* <div
        className={`note-sticky-form ${notesSidebar ? "d-block" : "d-none"}`}
      > */}
            {/* <Draggable handle=".head-move" cancel=".modal-body">
          <ResizableBox
            width={boxWidth}
            height={isNote ? boxHeight + 100 : boxHeight} // <-- FIXED
            style={{
              position: "fixed",
              top: "4%",
              left: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          > */}

            {/* //create task modal */}
            <Modal
                size="xl"
                isOpen={addTaskModal}
                toggle={() => setAddTaskModal(false)}
                className="modal-fullscreen"
            >
                <AddTasks
                    alldependency={alldependency}
                    tasks={tasks}
                    onCloseAddModal={() => setAddTaskModal(false)}
                    onChangeDrag={() => { }}
                    toggleLoading={(loading) =>
                        loading ? startLoading() : stopLoading()
                    }
                    updateData={() => { }}
                    tabType={0}
                    isLoading={isLoading}
                    presetTabValue="sales"
                    presetRelatedValue="lead"
                    presetRelatedId={lead_id}
                />
            </Modal>

            {/* //notes model */}
            <Modal
                size="xl"
                isOpen={notesSidebar}
                toggle={() => {
                    notesSidebar();
                }}
                className="modal-fullscreen"
            >
                <div className="px-3">
                    {/* Row 1 — Title + Close Button */}
                    <div className=" modal-header d-flex justify-content-between align-items-center">
                        <h5 className="mt-0 head-move">Add Note</h5>

                        <div className="company-info me-0 d-flex justify-content-center align-items-center">
                            <div className="d-flex justify-content-start align-items-center py-2 pt-3 gap-4">
                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-buildings-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.company}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-person-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.personName}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-telephone-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.phonenumber}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-envelope-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.email}
                                        </span>
                                    </h5>
                                </div>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => {
                                setNotesSidebar(false);
                                onFilter(null, leadType);
                                // ✅ Fix 2: reset form state on close
                                setCkedata("");
                                setAmount("");
                                setNotedate(curentDateTime);
                                setCurrency({ label: null, value: null });
                                setselectedFiles1([]);
                                setIsNote(false);
                                setTaskName("");
                                setPriority([]);
                                setAssignee([]);
                            }}
                            className="btn-modal-close"
                        >
                            <span aria-hidden="true" className="btn-modal-span">
                                &times;
                            </span>
                        </button>
                    </div>

                    {/* Row 2 — Company Info */}

                    {/* Row 3 — Lead Description */}
                    <Row>
                        <Col>
                            <div
                                className="bg-light rounded-3 p-3"
                                style={{
                                    maxHeight: "120px",
                                    overflowY: "auto",
                                    scrollbarWidth: "thin",
                                }}
                            >
                                <div className="fw-bold text-dark mb-2">Lead Description:</div>
                                <div
                                    className="text-muted"
                                    style={{
                                        wordBreak: "break-word",
                                        lineHeight: "1.5",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            leadDetail?.description || "No description available.",
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* BODY */}
                <div
                    className="px-3 pt-2 bg-white modal-body"
                    style={{
                        // maxHeight: boxHeight - 100, // adjust as needed
                        overflowY: "auto",
                    }}
                >
                    <div className="row">
                        {/* ================= Left Side (Notes History) ================= */}
                        <div className="col-md-6">
                            <h5 className="text-dark">Notes History</h5>

                            {/* <div
                    className="mt-4"
                    style={{
                      maxHeight: "450px",
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                    }}
                  > */}
                            <div
                                className="mt-4"
                                style={{
                                    maxHeight: boxHeight,
                                    overflowY: "auto",
                                    scrollbarWidth: "thin",
                                }}
                            >
                                <ul className="verti-timeline list-unstyled notes-box">
                                    {allNotes?.map((note, i) => {
                                        return (
                                            <li className="event-list position-relative" key={i}>
                                                <div className="event-timeline-dot connected-dot">
                                                    {note?.addedby_avatar ? (
                                                        <img
                                                            src={`${configure.imgUrl}/${note?.addedby_avatar}`}
                                                            className="msgUserImg me-3"
                                                            alt=""
                                                        />
                                                    ) : (
                                                        <div
                                                            className="defualt-img event-timeline-dot connected-dot"
                                                            title={note?.added_by}
                                                        >
                                                            {getInitials(note?.added_by || "Z")}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="d-flex">
                                                    <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div>
                                                                <p className="text-muted cursor-pointer">
                                                                    <h6 className="d-inline me-2">
                                                                        By {note.added_by}
                                                                    </h6>

                                                                    <Tooltip
                                                                        color="#f0e8f4"
                                                                        title={
                                                                            <div className="text-purple fw-bold body-font fs-6">
                                                                                <div>
                                                                                    UK Time:{" "}
                                                                                    {convertTimeZone(
                                                                                        note.created_at,
                                                                                        "Europe/London",
                                                                                        "DD-MM-YYYY hh:mm:ss a",
                                                                                    )}
                                                                                </div>

                                                                                <div>
                                                                                    US Time :{" "}
                                                                                    {moment(note.created_at)
                                                                                        .tz("America/New_York")
                                                                                        .format("DD-MM-YYYY hh:mm:ss a")}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    >
                                                                        {moment(note.created_at).format(
                                                                            "DD-MM-YYYY hh:mm:ss",
                                                                        )}
                                                                    </Tooltip>

                                                                    <span className="pl-15">
                                                                        Got in touch with this lead at{" "}
                                                                        <Tooltip
                                                                            color="#f0e8f4"
                                                                            title={
                                                                                <div className="text-purple fw-bold body-font fs-6">
                                                                                    <div>
                                                                                        UK Time:{" "}
                                                                                        {convertTimeZone(
                                                                                            note.date,
                                                                                            "Europe/London",
                                                                                        )}
                                                                                    </div>

                                                                                    <div>
                                                                                        US Time :{" "}
                                                                                        {convertTimeZone(
                                                                                            note.date,
                                                                                            "America/New_York",
                                                                                            "DD-MM-YYYY hh:mm:ss a",
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        >
                                                                            {moment(note.date).format(
                                                                                "DD-MM-YYYY hh:mm a",
                                                                            )}
                                                                        </Tooltip>
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <i className="bi bi-triangle-fill note-icon"></i>

                                                        <div
                                                            className="Features word-wrap"
                                                            dangerouslySetInnerHTML={{
                                                                __html: note.description,
                                                            }}
                                                        />

                                                        <p className="mb-2">
                                                            Amount : {note.currency_symbol} {note.amount}{" "}
                                                        </p>

                                                        {note.link != null ? (
                                                            <p className="mb-1">
                                                                Attachment :{" "}
                                                                <a
                                                                    target="_blank "
                                                                    className="btn btn-sm edit-delete-btn text-secondary ml-10"
                                                                    rel="noreferrer"
                                                                    type="button"
                                                                    href={note.link}
                                                                >
                                                                    <i className="fas fa-eye"></i> View
                                                                </a>
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                        {/* ================= Right Side (Add Note Form) ================= */}
                        <div
                            className="col-md-6"
                            style={{
                                maxHeight: { boxHeight },
                                overflowY: "auto",
                                scrollbarWidth: "thin",
                            }}
                        >
                            <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
                                <Form onSubmit={addNotes} className="w-100">
                                    <Row className="align-items-center justify-content-between">
                                        {/* Header */}
                                        <div className="col-12 d-flex justify-content-between align-items-center">
                                            {/* LEFT – Title */}
                                            <h5 className="text-dark">Add New Note</h5>

                                            {/* RIGHT – Toggle + Buttons */}
                                            <div className="d-flex align-items-center gap-3">
                                                {/* Toggle */}
                                                <div className="d-flex align-items-center">
                                                    <Label className="me-2 mb-0">Assign Task</Label>

                                                    <div className="form-switch form-switch-md">
                                                        <input
                                                            title="Assign Tasks"
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="customSwitchsizemd"
                                                            checked={isNote}
                                                            onClick={(e) => setIsNote(!e.target.checked)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Buttons */}
                                                <a
                                                    className="btn btn-save btn-label"
                                                    type="button"
                                                    href={`${configure.appUrl}calender/lead-${lead_id}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <i className="fa fa-users me-2 label-icon"></i>
                                                    Add Meeting
                                                </a>

                                                <button className="btn btn-save btn-label">
                                                    <i className="fas fa-plus me-2 label-icon"></i>
                                                    {isNote ? "Add Note & Task" : "Add Note"}
                                                </button>
                                            </div>
                                        </div>

                                        {/* ================= Task Toggle ================= */}
                                        {/* <div className="text-end me-3 align-items-center d-flex">
                          <Label htmlFor="formrow-firstname-Input">
                            Assign Task
                          </Label>
                          <div className="form-switch form-switch-md mb-2 mt-1">
                            <input
                              title="Assign Tasks"
                              type="checkbox"
                              className="form-check-input"
                              id="customSwitchsizemd"
                              // onClick={e => e.stopPropagation()}
                              checked={isNote || false}
                              onClick={e => setIsNote(!e.target.checked)}
                            />
                          </div>
                        </div> */}

                                        {/* ================= Task Fields ================= */}
                                        {isNote && (
                                            <div className="col-12 mt-3">
                                                <div className="row">
                                                    <div className="col-12 mb-3">
                                                        <label>
                                                            Enter Task Name{" "}
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Task Name"
                                                            value={taskName}
                                                            onChange={(e) => setTaskName(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="col-4 mb-3">
                                                        <label>
                                                            Assignee <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            placeholder="Select Assignee"
                                                            classNamePrefix="select"
                                                            options={alldependency?.users}
                                                            value={assignee}
                                                            onChange={(e) => setAssign(e)}
                                                        />
                                                    </div>

                                                    <div className="col-4 mb-3">
                                                        <label>
                                                            Priority <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            placeholder="Select Priority"
                                                            classNamePrefix="select"
                                                            options={priorityOption}
                                                            value={priority}
                                                            onChange={(e) => setPriority(e)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* ================= Description ================= */}
                                        <div className="mt-3" style={{ width: "98%" }}>
                                            <label htmlFor="">Description</label>
                                            <div
                                                className="no-drag"
                                                onDoubleClick={() => setNoDrag(true)}
                                                onMouseLeave={() => setNoDrag(false)}
                                                onMouseEnter={() => setNoDrag(true)}
                                            >
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={ckedata}
                                                    onReady={(editor) => { }}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        setCkedata(data);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Currency */}
                                        <div className="col-md-4 mt-3 px-0 ps-2">
                                            <label htmlFor="">Currency</label>
                                            <Select
                                                onChange={(e) =>
                                                    setCurrency({
                                                        label: e.label,
                                                        value: e.value,
                                                    })
                                                }
                                                placeholder="Select Currency"
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                styles={colourStyles}
                                                options={currency_option}
                                                menuPlacement="top"
                                            />
                                        </div>

                                        {/* Amount */}
                                        <div className="col-md-3 mt-3 px-0 ps-2">
                                            <label htmlFor="">Amount</label>
                                            <input
                                                type="number"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                placeholder="Enter Amount"
                                                className="form-control"
                                            />
                                        </div>

                                        {/* Got in touch date */}
                                        <div className="col-md-5 mt-3 notes pe-4">
                                            <label htmlFor="touch">
                                                Got in touch with this lead{" "}
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <input
                                                type="datetime-local"
                                                value={notedate}
                                                onChange={(e) => setNotedate(e.target.value)}
                                                required
                                                className="form-control"
                                            />
                                        </div>

                                        {/* Attachment */}
                                        <div className="col-md-6 mt-3">
                                            <label htmlFor="">Attachment</label>

                                            <Dropzone
                                                onDrop={(acceptedFiles) => {
                                                    handleAcceptedFiles1(acceptedFiles);
                                                }}
                                            >
                                                {({ getRootProps, getInputProps }) => (
                                                    <div
                                                        className="dz-message needsclick p-0"
                                                        {...getRootProps()}
                                                    >
                                                        <input {...getInputProps()} />

                                                        <div className="d-flex px-2 custom-file-upload align-items-center">
                                                            <div>
                                                                <i className="display-6 text-muted bx bxs-cloud-upload" />
                                                            </div>
                                                            <h5 className="mb-0 ms-2">Upload Files</h5>
                                                        </div>
                                                    </div>
                                                )}
                                            </Dropzone>
                                        </div>

                                        {/* Uploaded Files Preview */}
                                        <div
                                            className={`col-md-5 mt-3 dropzone-previews ${selectedFiles1.length > 0 ? "d-block" : "d-none"
                                                }`}
                                            id="file-previews"
                                        >
                                            <label className="mb-1">Uploaded Files</label>

                                            <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                                <div className="p-1">
                                                    <Row className="align-items-center justify-content-evenly">
                                                        {selectedFiles1.map((f, i) => {
                                                            return (
                                                                <Col key={i} className="col-auto">
                                                                    <img
                                                                        data-dz-thumbnail=""
                                                                        height="80"
                                                                        className="avatar-sm rounded bg-light"
                                                                        alt={f.name}
                                                                        src={f.preview}
                                                                    />
                                                                </Col>
                                                            );
                                                        })}
                                                    </Row>
                                                </div>
                                            </Card>
                                        </div>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Followup Model */}
            <Modal
                size="xl"
                isOpen={followupSidebar}
                toggle={() => {
                    followupSidebar();
                }}
                className="modal-fullscreen"
            >
                <div className="px-3">
                    {/* Row 1 — Title + Close Button */}
                    <div className=" modal-header d-flex justify-content-between align-items-center">
                        <h5 className="mt-0 head-move">Add Followup</h5>

                        <div className="company-info me-0 d-flex justify-content-center align-items-center">
                            <div className="d-flex justify-content-start align-items-center py-2 pt-3 gap-4">
                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-buildings-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.company}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-person-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.personName}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-telephone-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.phonenumber}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-envelope-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.email}
                                        </span>
                                    </h5>
                                </div>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => {
                                setFollowupSideBar(false);
                                setFilterFollowDate("");
                                setDescription("");
                                setNotedate("");
                                setAssign([]);
                                // fetch()
                            }}
                            className="btn-modal-close"
                        >
                            <span aria-hidden="true" className="btn-modal-span">
                                &times;
                            </span>
                        </button>
                    </div>

                    {/* Row 2 — Company Info */}

                    {/* Row 3 — Lead Description */}
                    <Row>
                        <Col>
                            <div
                                className="bg-light rounded-3 p-3"
                                style={{
                                    maxHeight: "120px",
                                    overflowY: "auto",
                                    scrollbarWidth: "thin",
                                }}
                            >
                                <div className="fw-bold text-dark mb-2">Lead Description:</div>
                                <div
                                    className="text-muted"
                                    style={{
                                        wordBreak: "break-word",
                                        lineHeight: "1.5",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            leadDetail?.description || "No description available.",
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* BODY */}
                <div
                    className="px-3 pt-2 bg-white modal-body"
                    style={{
                        // maxHeight: boxHeight - 100, // adjust as needed
                        overflowY: "auto",
                    }}
                >
                    <div className="row mt-4">
                        {/* ================= Left Side (Notes History) ================= */}
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <h5 className="text-dark">Followup History</h5>
                                <Select
                                    placeholder="Filter by date"
                                    isClearable
                                    value={filterFollowDate}
                                    className="basic-multi-select"
                                    classNamePrefix=" select"
                                    onChange={(e) => setFilterFollowDate(e)}
                                    options={[
                                        ...new Map(
                                            follow_data?.map((note) => {
                                                const d = moment(note.date_time).format("DD-MM-YYYY");
                                                return [
                                                    d,
                                                    {
                                                        label: d,
                                                        value: moment(note.date_time).format("YYYY-MM-DD"),
                                                    },
                                                ];
                                            }),
                                        ).values(),
                                    ]}
                                />
                            </div>
                            {/* <div
                    className="mt-4"
                    style={{
                      maxHeight: "450px",
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                    }}
                  > */}
                            <div
                                className="mt-4"
                                style={{
                                    maxHeight: boxHeight,
                                    overflowY: "auto",
                                    scrollbarWidth: "thin",
                                }}
                            >
                                <ul className="verti-timeline list-unstyled notes-box">
                                    {(filterFollowDate
                                        ? follow_data?.filter(
                                            (note) =>
                                                moment(note.date_time).format("YYYY-MM-DD") ===
                                                filterFollowDate?.value,
                                        )
                                        : follow_data
                                    )?.map((note, i) => {
                                        return (
                                            <li className="event-list position-relative" key={i}>
                                                <div className="event-timeline-dot connected-dot">
                                                    {note?.user_avatar ? (
                                                        <img
                                                            src={`${configure.imgUrl}/${note?.user_avatar}`}
                                                            className="msgUserImg me-3"
                                                            alt=""
                                                        />
                                                    ) : (
                                                        <div
                                                            className="defualt-img event-timeline-dot connected-dot"
                                                            title={note?.added_by}
                                                        >
                                                            {getInitials(note?.added_by || "Z")}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="d-flex">
                                                    <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div>
                                                                <p className="text-muted cursor-pointer">
                                                                    <h6 className="d-inline me-2">
                                                                        By {note.added_by}
                                                                    </h6>

                                                                    <Tooltip
                                                                        color="#f0e8f4"
                                                                        title={
                                                                            <div className="text-purple fw-bold body-font fs-6">
                                                                                <div>
                                                                                    UK Time:{" "}
                                                                                    {convertTimeZone(
                                                                                        note.created_at,
                                                                                        "Europe/London",
                                                                                        "DD-MM-YYYY hh:mm:ss a",
                                                                                    )}
                                                                                </div>

                                                                                <div>
                                                                                    US Time :{" "}
                                                                                    {moment(note.created_at)
                                                                                        .tz("America/New_York")
                                                                                        .format("DD-MM-YYYY hh:mm:ss a")}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    >
                                                                        {moment(note.created_at).format(
                                                                            "DD-MM-YYYY hh:mm:ss",
                                                                        )}
                                                                    </Tooltip>

                                                                    <h6 className="d-inline ms-3">
                                                                        Follow up at :
                                                                        <Tooltip
                                                                            color="#f0e8f4"
                                                                            className="ms-2"
                                                                            title={
                                                                                <div className="text-purple fw-bold body-font fs-6">
                                                                                    <div>
                                                                                        UK Time:{" "}
                                                                                        {convertTimeZone(
                                                                                            note.date_time,
                                                                                            "Europe/London",
                                                                                            "DD-MM-YYYY hh:mm:ss a",
                                                                                        )}
                                                                                    </div>

                                                                                    <div>
                                                                                        US Time :{" "}
                                                                                        {moment(note.date_time)
                                                                                            .tz("America/New_York")
                                                                                            .format("DD-MM-YYYY hh:mm:ss a")}
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        >
                                                                            {moment(note.date_time).format(
                                                                                "DD-MM-YYYY hh:mm:ss",
                                                                            )}
                                                                        </Tooltip>
                                                                    </h6>
                                                                    {/* <span className="pl-15">
                                    Got in touch with this lead at{" "}
                                    <Tooltip
                                      color="#f0e8f4"
                                      title={
                                        <div className="text-purple fw-bold body-font fs-6">
                                          <div>
                                            UK Time:{" "}
                                            {convertTimeZone(
                                              note.date,
                                              "Europe/London"
                                            )}
                                          </div>

                                          <div>
                                            US Time :{" "}
                                            {convertTimeZone(
                                              note.date,
                                              "America/New_York",
                                              "DD-MM-YYYY hh:mm:ss a"
                                            )}
                                          </div>
                                        </div>
                                      }
                                    >
                                      {moment(note.date).format(
                                        "DD-MM-YYYY hh:mm a"
                                      )}
                                    </Tooltip>
                                  </span> */}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <i className="bi bi-triangle-fill note-icon"></i>

                                                        {/* <p>
                              Description :
                            <div
                              className="Features word-wrap"
                              dangerouslySetInnerHTML={{
                                __html: note.description,
                              }}
                            />
                            </p> */}
                                                        <p className="mb-2">
                                                            Description : {note.description}{" "}
                                                        </p>

                                                        <p className="mb-2">
                                                            Asign User Name : {note.assign_user_name}{" "}
                                                        </p>

                                                        {note.link != null ? (
                                                            <p className="mb-1">
                                                                Attachment :{" "}
                                                                <a
                                                                    target="_blank "
                                                                    className="btn btn-sm edit-delete-btn text-secondary ml-10"
                                                                    rel="noreferrer"
                                                                    type="button"
                                                                    href={note.link}
                                                                >
                                                                    <i className="fas fa-eye"></i> View
                                                                </a>
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                        {/* ================= Right Side (Add Note Form) ================= */}
                        <div
                            className="col-md-6"
                            style={{
                                maxHeight: { boxHeight },
                                overflowY: "auto",
                                scrollbarWidth: "thin",
                            }}
                        >
                            <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
                                <Form onSubmit={addFollowup}>
                                    <Row className="align-items-center ">
                                        <div className="col-12 d-flex justify-content-between">
                                            <h5>Add New FollowUp</h5>
                                            <div className="text-end">
                                                <button className="btn btn-purple  me-2">
                                                    <i className="fas fa-plus me-2"></i>Add FollowUp
                                                </button>
                                                <a
                                                    onClick={() => {
                                                        setFollowupSideBar(false);
                                                        setDescription("");
                                                        setNotedate("");
                                                        setAssign([]);
                                                    }}
                                                    className="btn btn-red text-uppercase "
                                                >
                                                    <i className="dripicons-cross me-1 icon-center"></i>
                                                    Close
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mt-3 notes">
                                            <label htmlFor="touch">
                                                FollowUp Date <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                required
                                                value={notedate}
                                                onChange={(e) => setNotedate(e.target.value)}
                                                className="form-control "
                                            />
                                        </div>
                                        <div className="col-md-4 mt-4">
                                            <label htmlFor="">Assigned</label>
                                            <Select
                                                onChange={(e) => setAssign(e)}
                                                placeholder="Select"
                                                className="basic-multi-select"
                                                classNamePrefix=" select"
                                                value={assign}
                                                styles={colourStyles}
                                                isMulti
                                                options={assigned_data?.map((obj) => ({
                                                    label: obj.name,
                                                    value: obj.id,
                                                }))}
                                            />
                                        </div>

                                        <div className="col-12 mt-4">
                                            <label htmlFor="">Purpose</label>
                                            <textarea
                                                className="form-control"
                                                placeholder="Enter Purpose"
                                                onChange={(e) => setDescription(e.target.value)}
                                                style={{ height: "65px" }}
                                            ></textarea>
                                        </div>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* </ResizableBox>
        </Draggable>
      </div> */}
        </React.Fragment>
    );
};

export default Lead;
